
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("8V3kK", function(module, exports) {

$parcel$export(module.exports, "getGlobalErrorCount", () => $de4d720c68f73b15$export$d06c0426664e7c08);
$parcel$export(module.exports, "default", () => $de4d720c68f73b15$export$2e2bcd8739ae039);

var $cBeZP = parcelRequire("cBeZP");
let $de4d720c68f73b15$var$shouldInitilizeGlobalErrorHandler = true;
let $de4d720c68f73b15$var$globalCount = 0;
const $de4d720c68f73b15$var$errors = [];
let $de4d720c68f73b15$var$push = (name, labelStack, errorType, errorMessage, errorStack)=>{
    $de4d720c68f73b15$var$errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack
    });
};
const $de4d720c68f73b15$export$ebe081a8c9bf8176 = (sinkFunc)=>{
    $de4d720c68f73b15$var$push = sinkFunc;
    $de4d720c68f73b15$var$errors.forEach((e)=>{
        sinkFunc(e.name, e.labelStack, e.errorType, e.errorMessage, e.errorStack);
    });
    $de4d720c68f73b15$var$errors.length = 0;
};
const $de4d720c68f73b15$export$d06c0426664e7c08 = ()=>$de4d720c68f73b15$var$globalCount;
const $de4d720c68f73b15$var$handleError = (e)=>{
    $de4d720c68f73b15$var$globalCount++;
    if (e.error?.UFOhasCaught === undefined) try {
        if (e.error instanceof Error) $de4d720c68f73b15$var$push('GlobalErrorHandler', null, e.error.name, e.error.message, e.error.stack);
        else if (e.error) {
            const hint = JSON.stringify(e.error).slice(0, 50);
            $de4d720c68f73b15$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
        } else if (e.message !== undefined) {
            const hint = e.message.slice(0, 50);
            $de4d720c68f73b15$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
        }
        if (e.error && typeof e.error === 'object') e.error.UFOhasCaught = true;
    // eslint-disable-next-line no-empty
    } catch (e) {}
};
const $de4d720c68f73b15$var$handlePromiseRejection = (e)=>{
    $de4d720c68f73b15$var$globalCount++;
    if (e.reason instanceof Error) $de4d720c68f73b15$var$push('GlobalErrorHandler', null, e.reason.name, e.reason.message, e.reason.stack);
    else if (e.reason) try {
        const hint = JSON.stringify(e.reason).slice(0, 50);
        $de4d720c68f73b15$var$push('GlobalErrorHandler', null, '', `Non error object thrown: ${hint}`, undefined);
    // eslint-disable-next-line no-empty
    } catch (e) {}
};
const $de4d720c68f73b15$var$setupUFOGlobalErrorHandler = ()=>{
    if ($de4d720c68f73b15$var$shouldInitilizeGlobalErrorHandler) {
        (0, $cBeZP.bind)(window, {
            type: 'error',
            listener: (e)=>$de4d720c68f73b15$var$handleError(e)
        });
        (0, $cBeZP.bind)(window, {
            type: 'unhandledrejection',
            listener: $de4d720c68f73b15$var$handlePromiseRejection
        });
        $de4d720c68f73b15$var$shouldInitilizeGlobalErrorHandler = false;
    }
};
var $de4d720c68f73b15$export$2e2bcd8739ae039 = $de4d720c68f73b15$var$setupUFOGlobalErrorHandler;

});

parcelRegister("aPYC0", function(module, exports) {

$parcel$export(module.exports, "getCookie", () => $7ae32a5e97a9e40e$export$4be65e66cfa2648a);

var $eYli8 = parcelRequire("eYli8");

var $cBZhf = parcelRequire("cBZhf");

var $3f7UC = parcelRequire("3f7UC");

var $f2jPu = parcelRequire("f2jPu");
function $7ae32a5e97a9e40e$export$4be65e66cfa2648a(key) {
    if ((0, $cBZhf.fg)('platform_moonjelly_bsc_master_killswitch')) // Get the cookie without package operational events
    // when master killswitch is enabled
    return key ? (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get();
    try {
        (0, $3f7UC.sendPackageOperationalEvent)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get();
    } catch (e) {
        (0, $f2jPu.Logger).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}

});
parcelRegister("3f7UC", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsClient", () => $c4f1b5c6ad920e91$export$fde53e78fd93a54d);
$parcel$export(module.exports, "sendPackageOperationalEvent", () => $c4f1b5c6ad920e91$export$5bfe55348e7aebc1);
$parcel$export(module.exports, "sendUIEvent", () => $c4f1b5c6ad920e91$export$1aecf263098db667);
$parcel$export(module.exports, "sendScreenEvent", () => $c4f1b5c6ad920e91$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendTrackEvent", () => $c4f1b5c6ad920e91$export$1ba525b8a711eaac);

var $aDtD9 = parcelRequire("aDtD9");
var $jBaqB = parcelRequire("jBaqB");

var $9gGZS = parcelRequire("9gGZS");

var $f2jPu = parcelRequire("f2jPu");

var $fuTfQ = parcelRequire("fuTfQ");

var $cOBmh = parcelRequire("cOBmh");
const $c4f1b5c6ad920e91$var$getEnvironment = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.')) return (0, $jBaqB.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, $jBaqB.envType).DEV;
    return (0, $jBaqB.envType).PROD;
};
const $c4f1b5c6ad920e91$export$78d7c0236b4fece9 = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const $c4f1b5c6ad920e91$var$getProductFromDomain = (domain)=>{
    if (domain === 'https://trello.com') return 'trello';
    return null;
};
const $c4f1b5c6ad920e91$export$fce3dd735e04d566 = ()=>{
    const { origin: origin, pathname: pathname } = window.location;
    const productPath = $c4f1b5c6ad920e91$export$78d7c0236b4fece9(pathname);
    const domain = `${origin}${productPath}`;
    const product = $c4f1b5c6ad920e91$var$getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
const $c4f1b5c6ad920e91$var$decorateEventAttributes = (attributes)=>{
    const { domain: domain, product: product } = $c4f1b5c6ad920e91$export$fce3dd735e04d566();
    return {
        packageName: $fuTfQ.packageName,
        packageVersion: $fuTfQ.packageVersion,
        domain: domain,
        product: (0, $9gGZS.getBscGlobalState)().product?.toLowerCase() ?? product,
        ...attributes && attributes
    };
};
const $c4f1b5c6ad920e91$export$fde53e78fd93a54d = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, $9gGZS.getBscGlobalState)().analyticsEnabled) instance = new (0, $aDtD9.default)({
                env: $c4f1b5c6ad920e91$var$getEnvironment(),
                product: 'atlassianCookies'
            }, {
                // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                // When set to false, the client will use a stargate proxy for the current URL to send events
                // to GAS. Said another way:
                // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                // false => events are sent to <the current domain>/gasv3/api/v1/batch
                //
                // By default, this should be set to false.  If you need to validate that analytics events
                // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                // won't be able to proxy to GAS via stargate.
                useLegacyUrl: false,
                disableCookiePersistence: true
            });
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            (0, $f2jPu.Logger).error(`Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, $9gGZS.getBscGlobalState)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function $c4f1b5c6ad920e91$export$5bfe55348e7aebc1(properties) {
    (0, $cOBmh.withAnalyticsEventSampling)(properties.action, ()=>$c4f1b5c6ad920e91$export$fde53e78fd93a54d()?.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: $c4f1b5c6ad920e91$var$decorateEventAttributes(properties.attributes)
        }));
}
function $c4f1b5c6ad920e91$export$1aecf263098db667(properties) {
    $c4f1b5c6ad920e91$export$fde53e78fd93a54d()?.sendUIEvent({
        ...properties,
        attributes: $c4f1b5c6ad920e91$var$decorateEventAttributes(properties.attributes)
    });
}
function $c4f1b5c6ad920e91$export$22a3b1671f38a193(properties) {
    $c4f1b5c6ad920e91$export$fde53e78fd93a54d()?.sendScreenEvent({
        ...properties,
        attributes: $c4f1b5c6ad920e91$var$decorateEventAttributes(properties.attributes)
    });
}
function $c4f1b5c6ad920e91$export$1ba525b8a711eaac(properties) {
    $c4f1b5c6ad920e91$export$fde53e78fd93a54d()?.sendTrackEvent({
        ...properties,
        attributes: $c4f1b5c6ad920e91$var$decorateEventAttributes(properties.attributes)
    });
}

});
parcelRegister("9gGZS", function(module, exports) {

$parcel$export(module.exports, "getBscGlobalState", () => $4cff526c28a31edd$export$3b78a1ea01f5ec28);
$parcel$export(module.exports, "initializeGlobalState", () => $4cff526c28a31edd$export$882c4530c58781d8);

var $eYli8 = parcelRequire("eYli8");

var $cBZhf = parcelRequire("cBZhf");

var $42rNK = parcelRequire("42rNK");

var $6Fsy6 = parcelRequire("6Fsy6");

var $f2jPu = parcelRequire("f2jPu");
let $4cff526c28a31edd$var$localAnalyticsEnabled;
let $4cff526c28a31edd$var$localProduct;
let $4cff526c28a31edd$var$webStorageControlsEnabled;
let $4cff526c28a31edd$var$localConsentModeEnabled;
let $4cff526c28a31edd$var$packageDebugModeEnabled;
let $4cff526c28a31edd$var$localAllowUncategorizedCookiesInOverrides;
let $4cff526c28a31edd$var$cookiesCacheLoader;
let $4cff526c28a31edd$var$localStorageCacheLoader;
let $4cff526c28a31edd$var$sessionStorageCacheLoader;
let $4cff526c28a31edd$var$loadCache = async (storageType)=>{
    switch(storageType){
        case (0, $42rNK.CategoryStorageType).Cookies:
            return await $4cff526c28a31edd$var$cookiesCacheLoader?.loadStorageControlsData();
        case (0, $42rNK.CategoryStorageType).LocalStorage:
            return await $4cff526c28a31edd$var$localStorageCacheLoader?.loadStorageControlsData();
        case (0, $42rNK.CategoryStorageType).SessionStorage:
            return await $4cff526c28a31edd$var$sessionStorageCacheLoader?.loadStorageControlsData();
        default:
            return undefined;
    }
};
const $4cff526c28a31edd$export$3b78a1ea01f5ec28 = ()=>{
    if ($4cff526c28a31edd$var$localAnalyticsEnabled == null) $4cff526c28a31edd$var$localAnalyticsEnabled = true;
    // Unless specified, localConsentMode is turned off
    $4cff526c28a31edd$var$localConsentModeEnabled = $4cff526c28a31edd$var$localConsentModeEnabled ?? false;
    return {
        analyticsEnabled: $4cff526c28a31edd$var$localAnalyticsEnabled,
        product: $4cff526c28a31edd$var$localProduct,
        webStorageEnabled: $4cff526c28a31edd$var$webStorageControlsEnabled,
        localConsentMode: $4cff526c28a31edd$var$localConsentModeEnabled,
        packageDebugMode: $4cff526c28a31edd$var$packageDebugModeEnabled,
        allowUncategorizedCookiesInOverrides: $4cff526c28a31edd$var$localAllowUncategorizedCookiesInOverrides,
        cookiesCacheLoader: $4cff526c28a31edd$var$cookiesCacheLoader,
        localStorageCacheLoader: $4cff526c28a31edd$var$localStorageCacheLoader,
        sessionStorageCacheLoader: $4cff526c28a31edd$var$sessionStorageCacheLoader,
        loadCache: $4cff526c28a31edd$var$loadCache
    };
};
const $4cff526c28a31edd$export$882c4530c58781d8 = ({ analyticsEnabled: analyticsEnabled = true, product: product = 'all', localConsentMode: localConsentMode = false, webStorageEnabled: webStorageEnabled, allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides } = {})=>{
    (0, $f2jPu.Logger).debug('Initialize global state invoked');
    $4cff526c28a31edd$var$localAnalyticsEnabled = analyticsEnabled;
    $4cff526c28a31edd$var$localProduct = product;
    $4cff526c28a31edd$var$localConsentModeEnabled = localConsentMode;
    // Only set webStorageControlsEnabled if webStorageEnabled is defined
    if (webStorageEnabled !== undefined) $4cff526c28a31edd$var$webStorageControlsEnabled = webStorageEnabled && !(0, $cBZhf.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $cBZhf.fg)('platform_moonjelly_bsc_web_storage_killswitch');
    if (allowUncategorizedCookiesInOverrides !== undefined) $4cff526c28a31edd$var$localAllowUncategorizedCookiesInOverrides = allowUncategorizedCookiesInOverrides;
    $4cff526c28a31edd$var$cookiesCacheLoader = new (0, $6Fsy6.CacheLoader)((0, $42rNK.CategoryStorageType).Cookies);
    $4cff526c28a31edd$var$localStorageCacheLoader = new (0, $6Fsy6.CacheLoader)((0, $42rNK.CategoryStorageType).LocalStorage);
    $4cff526c28a31edd$var$sessionStorageCacheLoader = new (0, $6Fsy6.CacheLoader)((0, $42rNK.CategoryStorageType).SessionStorage);
    if ((0, $cBZhf.fg)('platform_moonjelly_bsc_debug_mode')) $4cff526c28a31edd$var$packageDebugModeEnabled = Boolean((0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get('atl-bsc-debug-mode'));
};
const $4cff526c28a31edd$export$f86e17381f699baf = ({ loadCache: overrideLoadCache, product: overrideProduct })=>{
    if (overrideLoadCache) $4cff526c28a31edd$var$loadCache = overrideLoadCache;
    if (overrideProduct) $4cff526c28a31edd$var$localProduct = overrideProduct;
};
const $4cff526c28a31edd$export$ac7c2edd09656c05 = ()=>{
    $4cff526c28a31edd$var$localAnalyticsEnabled = undefined;
    $4cff526c28a31edd$var$localProduct = undefined;
    $4cff526c28a31edd$var$webStorageControlsEnabled = undefined;
    $4cff526c28a31edd$var$localConsentModeEnabled = undefined;
    $4cff526c28a31edd$var$packageDebugModeEnabled = undefined;
    $4cff526c28a31edd$var$localAllowUncategorizedCookiesInOverrides = undefined;
    $4cff526c28a31edd$var$cookiesCacheLoader = undefined;
    $4cff526c28a31edd$var$localStorageCacheLoader = undefined;
    $4cff526c28a31edd$var$sessionStorageCacheLoader = undefined;
};

});
parcelRegister("42rNK", function(module, exports) {

$parcel$export(module.exports, "PreferenceCategory", () => $0444b1f3d56873cb$export$ba064dbfe4bb66d7);
$parcel$export(module.exports, "ConsentPreferenceV2", () => $0444b1f3d56873cb$export$cdef20bac194f235);
$parcel$export(module.exports, "ContextualConsentProperty", () => $0444b1f3d56873cb$export$fac80ad19b60e313);
$parcel$export(module.exports, "PrefetchedPreferenceState", () => $0444b1f3d56873cb$export$5d6594a0bba4ab8a);
$parcel$export(module.exports, "CategoryStorageType", () => $0444b1f3d56873cb$export$2506b012eb637f61);
$parcel$export(module.exports, "Status", () => $0444b1f3d56873cb$export$96e9906d6d93a972);
var $0444b1f3d56873cb$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
var $0444b1f3d56873cb$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
var $0444b1f3d56873cb$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
var $0444b1f3d56873cb$export$4fda8eb914d6791c = /*#__PURE__*/ function(CachedKeysDataPropertyLegacy) {
    CachedKeysDataPropertyLegacy["LocalStorage"] = "localStorageKeys";
    CachedKeysDataPropertyLegacy["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataPropertyLegacy["Cookies"] = "keys";
    CachedKeysDataPropertyLegacy["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataPropertyLegacy;
}({});
var $0444b1f3d56873cb$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
var $0444b1f3d56873cb$export$2506b012eb637f61 = /*#__PURE__*/ function(CategoryStorageType) {
    CategoryStorageType["Cookies"] = "Cookies";
    CategoryStorageType["LocalStorage"] = "LocalStorage";
    CategoryStorageType["SessionStorage"] = "SessionStorage";
    return CategoryStorageType;
}({});
var $0444b1f3d56873cb$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    return Status;
}({});
var $0444b1f3d56873cb$export$eefdbcf75990494a = /*#__PURE__*/ function(BSC_PACKAGE_KILLSWITCHES) {
    BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
    BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
    BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
    BSC_PACKAGE_KILLSWITCHES["WEB_STORAGE_KILLSWITCH"] = "platform_moonjelly_bsc_web_storage_killswitch";
    return BSC_PACKAGE_KILLSWITCHES;
}({});

});

parcelRegister("6Fsy6", function(module, exports) {

$parcel$export(module.exports, "CacheLoader", () => $1ac977270eafaaa9$export$e479342c697b82a9);

var $42rNK = parcelRequire("42rNK");

var $f2jPu = parcelRequire("f2jPu");

class $1ac977270eafaaa9$export$e479342c697b82a9 {
    constructor(storageType){
        switch(storageType){
            case (0, $42rNK.CategoryStorageType).Cookies:
                this.cacheUrl = (0, $187382e70e0d1e3e$export$ab0619f627170401);
                break;
            case (0, $42rNK.CategoryStorageType).LocalStorage:
                this.cacheUrl = (0, $187382e70e0d1e3e$export$38bed9fd9923fef3);
                break;
            case (0, $42rNK.CategoryStorageType).SessionStorage:
                this.cacheUrl = (0, $187382e70e0d1e3e$export$4f73a4b5fdb7ed6c);
                break;
            default:
                this.cacheUrl = (0, $187382e70e0d1e3e$export$194c34963e6f0bc6);
        }
    }
    clearStorageControlsDataCache() {
        this.localResponseCache = undefined;
        this.localResponsePromiseCache = undefined;
        this.localResponseJsonPromiseCache = undefined;
    }
    /**
	 * Unpacks the response promise from the categories CDN
	 *
	 * errors if that request was unsuccessful, returns the categories data otherwise
	 *
	 */ async handleCategoriesResponse(responsePromise) {
        if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
        const response = await responsePromise;
        if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
        // Checks if we've already fired the response.json() promise
        this.localResponseJsonPromiseCache = this.localResponseJsonPromiseCache || response?.json();
        return this.localResponseJsonPromiseCache;
    }
    async loadStorageControlsData() {
        if (this.localResponseCache) return this.localResponseCache;
        else // Always use Prod CDN for prod/local/dev/staging environments, but stub the route for automation tests
        try {
            if (!this.localResponsePromiseCache) {
                (0, $f2jPu.Logger).debug(`Loading cache ${this.cacheUrl}`);
                // invoke CDN and cache the promise
                this.localResponsePromiseCache = fetch(this.cacheUrl);
            }
            // unpack response
            this.localResponseCache = await this.handleCategoriesResponse(this.localResponsePromiseCache);
            return this.localResponseCache;
        } catch (e) {
            (0, $f2jPu.Logger).errorWithOperationalEvent({
                action: 'loadStorageControlsError',
                message: e.message || ''
            });
            this.clearStorageControlsDataCache();
        }
    }
}

});
parcelRegister("f2jPu", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $2dfc9d27746e32f3$export$efa9a398d6368992);
/* eslint-disable no-console */ 
var $cBZhf = parcelRequire("cBZhf");

var $3f7UC = parcelRequire("3f7UC");

var $9gGZS = parcelRequire("9gGZS");
const $2dfc9d27746e32f3$var$LOG_PREFIX = '[browser-storage-controls]';
class $2dfc9d27746e32f3$export$efa9a398d6368992 {
    static info(message, metadata) {
        console.log(`${$2dfc9d27746e32f3$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static error(message, metadata) {
        console.error(`${$2dfc9d27746e32f3$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
        try {
            (0, $3f7UC.sendPackageOperationalEvent)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata ? JSON.stringify(metadata) : '');
    }
    static warn(message, metadata) {
        console.warn(`${$2dfc9d27746e32f3$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    /**
	 * Logger for additional debugging of the package. Debug logs are only sent when the
	 * atl-bsc-debug-mode cookie is set on the browser. This is evaluated via global state
	 */ static debug(message, metadata) {
        if ((0, $9gGZS.getBscGlobalState)().packageDebugMode && (0, $cBZhf.fg)('platform_moonjelly_bsc_debug_mode')) console.debug(`${$2dfc9d27746e32f3$var$LOG_PREFIX}: DEBUG ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
}

});

const $187382e70e0d1e3e$export$194c34963e6f0bc6 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories.json';
const $187382e70e0d1e3e$export$ab0619f627170401 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_COOKIE.json';
const $187382e70e0d1e3e$export$38bed9fd9923fef3 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_LOCAL_STORAGE.json';
const $187382e70e0d1e3e$export$4f73a4b5fdb7ed6c = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_SESSION_STORAGE.json';



parcelRegister("fuTfQ", function(module, exports) {

$parcel$export(module.exports, "packageName", () => $2686a2d1f7c1d2e6$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $2686a2d1f7c1d2e6$export$91546b032799aa40);

var $6cAn5 = parcelRequire("6cAn5");
const $2686a2d1f7c1d2e6$export$9345d7360ffe0722 = $6cAn5?.env._PACKAGE_NAME_ ?? '';
const $2686a2d1f7c1d2e6$export$91546b032799aa40 = $6cAn5?.env._PACKAGE_VERSION_ ?? '';

});

parcelRegister("cOBmh", function(module, exports) {

$parcel$export(module.exports, "withAnalyticsEventSampling", () => $2e9937999d886b49$export$67b6e87f323cb6ad);

var $42rNK = parcelRequire("42rNK");

var $9gGZS = parcelRequire("9gGZS");

var $4oUl6 = parcelRequire("4oUl6");

var $4M4cC = parcelRequire("4M4cC");
const $2e9937999d886b49$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1,
    usedAtlBrowserStorageGetItem: 100,
    usedAtlBrowserStorageGetItemError: 1,
    usedAtlBrowserStorageSetItem: 100,
    usedAtlBrowserStorageSetItemError: 1,
    usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
    usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
    usedCheckIfSetByPackageError: 1,
    renderConsentBannerError: 1,
    bannerAppearanceAfterDismissal: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const $2e9937999d886b49$var$localOnlySamplingKeys = [
    'loadStorageControlsError'
];
async function $2e9937999d886b49$var$loadSamplingConfig() {
    if ((0, $4oUl6.cache).cachedSamplingConfig) return (0, $4oUl6.cache).cachedSamplingConfig;
    if ((0, $4M4cC.isSSR)()) return undefined;
    const { loadCache: loadCache } = (0, $9gGZS.getBscGlobalState)();
    const controlsData = await loadCache((0, $42rNK.CategoryStorageType).Cookies);
    const analyticsSamplingRatioConfigs = controlsData?.analyticsSamplingRatio;
    (0, $4oUl6.cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function $2e9937999d886b49$export$b286f5e8716d11ad(analyticsEventKey) {
    if ($2e9937999d886b49$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $2e9937999d886b49$export$1138592b3c099377[analyticsEventKey];
    const remoteSamplingConfig = await $2e9937999d886b49$var$loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig ?? $2e9937999d886b49$export$1138592b3c099377;
    const samplingRatio = samplingConfig?.[analyticsEventKey] !== undefined ? samplingConfig[analyticsEventKey] : $2e9937999d886b49$export$1138592b3c099377[analyticsEventKey];
    return samplingRatio;
}
function $2e9937999d886b49$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
       ________
      /\       \
     /()\   ()  \
    /    \_______\
    \    /()     /
     \()/   ()  /
      \/_____()/
  */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function $2e9937999d886b49$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
    const ratio = await $2e9937999d886b49$export$b286f5e8716d11ad(analyticsEventKey);
    $2e9937999d886b49$export$dc2f0946255b3f89(ratio, cb);
}

});
parcelRegister("4oUl6", function(module, exports) {

$parcel$export(module.exports, "cache", () => $c11bb9e146cd6ac6$export$69a3209f1a06c04d);

var $3foUD = parcelRequire("3foUD");
const $c11bb9e146cd6ac6$export$69a3209f1a06c04d = new (0, $3foUD.CachedSamplingConfig)();

});
parcelRegister("3foUD", function(module, exports) {

$parcel$export(module.exports, "CachedSamplingConfig", () => $8d5c3b7a32b10f71$export$b886edaf6623554a);
class $8d5c3b7a32b10f71$export$b886edaf6623554a {
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
}

});


parcelRegister("4M4cC", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $dc940ce73112dd49$export$48d7c418edadb60c);

var $aDtD9 = parcelRequire("aDtD9");

var $cBZhf = parcelRequire("cBZhf");

var $f2jPu = parcelRequire("f2jPu");
const $dc940ce73112dd49$export$48d7c418edadb60c = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, $cBZhf.fg);
    const isMissingAnalyticsWebClient = !Boolean((0, $aDtD9.default));
    // When rendering from the server document/window may not be available
    if (isMissingNecessaryBrowserUtils) (0, $f2jPu.Logger).warn('Browser context is not available.');
    if (isMissingBooleanFF) (0, $f2jPu.Logger).warn('Platform Feature Flag library is not available');
    if (!(0, $aDtD9.default)) (0, $f2jPu.Logger).warn('analytics-web-client is not available');
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};

});




parcelRegister("l27qC", function(module, exports) {

$parcel$export(module.exports, "default", () => $21bae23d3f63ea8f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useInteractionContext", () => $21bae23d3f63ea8f$export$11bcb6e9af2aca35);

var $5uXOq = parcelRequire("5uXOq");

var $inU3Q = parcelRequire("inU3Q");
var $21bae23d3f63ea8f$export$2e2bcd8739ae039 = (0, $inU3Q.default);
function $21bae23d3f63ea8f$export$11bcb6e9af2aca35() {
    return (0, $5uXOq.useContext)((0, $inU3Q.default));
}

});

parcelRegister("4raQk", function(module, exports) {

$parcel$export(module.exports, "browserMetrics", () => $f56fa0a24227bb96$export$c08e7affcf78b064);

var $kSR8I = parcelRequire("kSR8I");

var $iNoUK = parcelRequire("iNoUK");

var $hIyDI = parcelRequire("hIyDI");

var $jpJNv = parcelRequire("jpJNv");

var $fdKY9 = parcelRequire("fdKY9");

var $ffpPO = parcelRequire("ffpPO");

var $jNWGz = parcelRequire("jNWGz");

var $2n5zh = parcelRequire("2n5zh");
const $f56fa0a24227bb96$var$makeBrowserMetrics = ()=>{
    const bm = {
        init (config) {
            (0, $jpJNv.visibilityChangeObserver).start();
            if (config.events[(0, $2n5zh.BMEventsType).WEB_VITALS]?.enabled) (0, $fdKY9.webVitalsObserver).start();
            if (config.debug) {
                (0, $iNoUK.logger).enable();
                (0, $jNWGz.submitter).setDebug(true);
                (0, $hIyDI.pageLoadMetaMetric).setDebug(true);
            }
            (0, $jNWGz.submitter).configure(config);
            if (config.ssr?.getDoneMark) (0, $kSR8I.SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
        },
        setRoute (newRoute) {
            (0, $ffpPO.Route).setRoute(newRoute);
        },
        startPageLoad (params) {
            (0, $hIyDI.pageLoadMetaMetric).startPageLoad({
                isInitial: false,
                cancelStarted: true,
                ...params
            });
        },
        getPageLoadMetric () {
            return 0, $hIyDI.pageLoadMetaMetric;
        },
        experimental__addPageLoadTimingFromPerformanceMarks (name, startMark, stopMark, initialOnly = true) {
            if (initialOnly && !(0, $hIyDI.pageLoadMetaMetric).isInitialLoad()) return;
            const start = performance.getEntriesByName(startMark);
            const stop = performance.getEntriesByName(stopMark);
            if (start.length > 0 && stop.length > 0) {
                if ((0, $hIyDI.pageLoadMetaMetric).isDebugMode()) try {
                    performance.measure(name, startMark, stopMark);
                } catch (e) {}
                const pageLoadData = (0, $hIyDI.pageLoadMetaMetric).getData();
                if (pageLoadData.start !== null) {
                    const startMark = start[start.length - 1];
                    const timing = {
                        startTime: Math.round(startMark.startTime - pageLoadData.start),
                        duration: Math.round(stop[stop.length - 1].startTime - startMark.startTime)
                    };
                    (0, $hIyDI.pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                }
            }
        }
    };
    return bm;
};
const $f56fa0a24227bb96$export$c08e7affcf78b064 = $f56fa0a24227bb96$var$makeBrowserMetrics();

});
parcelRegister("kSR8I", function(module, exports) {

$parcel$export(module.exports, "SSRGetDoneMark", () => $99473cfe09e5b5a9$export$9e87a201397ac0a9);
const $99473cfe09e5b5a9$export$9e87a201397ac0a9 = {
    getDoneMark: ()=>null,
    setGetDoneMark: (fn)=>{
        $99473cfe09e5b5a9$export$9e87a201397ac0a9.getDoneMark = fn;
    }
};

});

parcelRegister("iNoUK", function(module, exports) {

$parcel$export(module.exports, "logger", () => $f3ad629c30bcb163$export$af88d00dbe7f521);
const $f3ad629c30bcb163$export$af88d00dbe7f521 = {
    enabled: false,
    enable () {
        this.enabled = true;
    },
    log (...args) {
        if (this.enabled) // eslint-disable-next-line no-console
        console.log('BM log: ', ...args);
    },
    logCond (condition, ...args) {
        if (this.enabled && condition && args.length > 1) this.log(...args);
    }
};

});

parcelRegister("hIyDI", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetaMetric", () => $bda13a524ed5787f$export$24b7a1a311eb05dc);

var $2n5zh = parcelRequire("2n5zh");

var $a4Xpq = parcelRequire("a4Xpq");

var $dxIdG = parcelRequire("dxIdG");
class $bda13a524ed5787f$export$9609608c00ea5077 extends (0, $dxIdG.BasePageLoadMetric) {
    startPageLoad({ cancelStarted: cancelStarted, ...startPageLoadParams } = {
        isInitial: false,
        cancelStarted: false
    }) {
        if (cancelStarted || this.state !== (0, $a4Xpq.MetricState).STARTED) super.startPageLoad(startPageLoadParams);
    }
    setActive(metric) {
        this.activePageLoadMetric = metric;
    }
    setDebug(debug) {
        this.config.debug = debug;
    }
    isDebugMode() {
        return this.config.debug;
    }
    isInitialLoad() {
        return this.isInitial;
    }
    clear() {
        this.activePageLoadMetric && this.activePageLoadMetric.cancel();
        super.clear();
    }
    include(metric) {
        if (!this.config.include) this.config.include = [
            metric
        ];
        else this.config.include.push(metric);
    }
    experimental__addExplicitTiming(name, timing) {
        if (this.explicitTimings === null) this.explicitTimings = {};
        this.explicitTimings[name] = timing;
    }
    constructor(...args){
        super(...args), this.activePageLoadMetric = null;
    }
}
const $bda13a524ed5787f$export$24b7a1a311eb05dc = new $bda13a524ed5787f$export$9609608c00ea5077({
    type: (0, $2n5zh.BMEventsType).PAGE_LOAD,
    key: 'page_load_meta_metric'
});

});
parcelRegister("2n5zh", function(module, exports) {

$parcel$export(module.exports, "BMEventsType", () => $7d19cf8e2ac5f718$export$9c73e297d4be9159);
$parcel$export(module.exports, "StorableBMEventsType", () => $7d19cf8e2ac5f718$export$9b7037ec30489597);
$parcel$export(module.exports, "BMPageLoadMetrics", () => $7d19cf8e2ac5f718$export$74c1fb0997d51e2a);
$parcel$export(module.exports, "BMPageSegmentLoadMetrics", () => $7d19cf8e2ac5f718$export$88195ac8200d03a6);
$parcel$export(module.exports, "BMInteractionMetrics", () => $7d19cf8e2ac5f718$export$6e28252a002afdb2);
$parcel$export(module.exports, "PageSegmentPageLoadMetricsOptions", () => $7d19cf8e2ac5f718$export$474154836bfd8dd9);
$parcel$export(module.exports, "PageVisibleFields", () => $7d19cf8e2ac5f718$export$e89802082dab5633);
$parcel$export(module.exports, "PageVisibleValueOrigin", () => $7d19cf8e2ac5f718$export$983b017156c2aee2);
$parcel$export(module.exports, "isDetailedPageLoadSlo", () => $7d19cf8e2ac5f718$export$5866f95702a15142);
$parcel$export(module.exports, "isDetailedPageSegmentLoadSlo", () => $7d19cf8e2ac5f718$export$f087a59bd717e49d);
$parcel$export(module.exports, "isInteractionMetricsSlo", () => $7d19cf8e2ac5f718$export$b10c1d9a7db7765b);
$parcel$export(module.exports, "IncludeSSRFeatureFlagsConfig", () => $7d19cf8e2ac5f718$export$60c0193054fc3040);

var $a4Xpq = parcelRequire("a4Xpq");
var $7d19cf8e2ac5f718$export$9c73e297d4be9159 = /*#__PURE__*/ function(BMEventsType) {
    BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
    BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
    BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
    BMEventsType["CUSTOM"] = "CUSTOM";
    BMEventsType["WEB_VITALS"] = "WEB_VITALS";
    return BMEventsType;
}({});
var $7d19cf8e2ac5f718$export$9b7037ec30489597 = /*#__PURE__*/ function(StorableBMEventsType) {
    StorableBMEventsType["PAGE_LOAD"] = "page-load";
    StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
    StorableBMEventsType["INLINE_RESULT"] = "inline-result";
    StorableBMEventsType["CUSTOM"] = "custom";
    StorableBMEventsType["WEB_VITALS"] = "web-vitals";
    return StorableBMEventsType;
}({});
var $7d19cf8e2ac5f718$export$74c1fb0997d51e2a = /*#__PURE__*/ function(BMPageLoadMetrics) {
    BMPageLoadMetrics["fmp"] = "fmp";
    BMPageLoadMetrics["tti"] = "tti";
    return BMPageLoadMetrics;
}({});
var $7d19cf8e2ac5f718$export$88195ac8200d03a6 = /*#__PURE__*/ function(BMPageSegmentLoadMetrics) {
    BMPageSegmentLoadMetrics["fmp"] = "fmp";
    BMPageSegmentLoadMetrics["tti"] = "tti";
    return BMPageSegmentLoadMetrics;
}({});
var $7d19cf8e2ac5f718$export$6e28252a002afdb2 = /*#__PURE__*/ function(BMInteractionMetrics) {
    BMInteractionMetrics["response"] = "response";
    BMInteractionMetrics["result"] = "result";
    return BMInteractionMetrics;
}({});
var $7d19cf8e2ac5f718$export$474154836bfd8dd9 = /*#__PURE__*/ function(PageSegmentPageLoadMetricsOptions) {
    PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
    PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
    PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
    return PageSegmentPageLoadMetricsOptions;
}({});
var $7d19cf8e2ac5f718$export$e89802082dab5633 = /*#__PURE__*/ function(PageVisibleFields) {
    PageVisibleFields["pageVisibleState"] = "page-visible-state";
    PageVisibleFields["pageVisibleValue"] = "page-visible-value";
    return PageVisibleFields;
}({});
var $7d19cf8e2ac5f718$export$983b017156c2aee2 = /*#__PURE__*/ function(PageVisibleValueOrigin) {
    PageVisibleValueOrigin["documentHidden"] = "document-hidden";
    PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
    return PageVisibleValueOrigin;
}({});
const $7d19cf8e2ac5f718$export$5866f95702a15142 = (data)=>{
    return Boolean(data.initial);
};
const $7d19cf8e2ac5f718$export$f087a59bd717e49d = (data)=>{
    return Boolean(data.initial);
};
const $7d19cf8e2ac5f718$export$153c4c72fa5eeece = (data)=>{
    const obj = data;
    return Boolean(obj.fmp !== undefined || obj.tti !== undefined);
};
const $7d19cf8e2ac5f718$export$b10c1d9a7db7765b = (data)=>{
    const obj = data;
    return Boolean(obj.result !== undefined || obj.response !== undefined);
};
var $7d19cf8e2ac5f718$export$60c0193054fc3040 = /*#__PURE__*/ function(IncludeSSRFeatureFlagsConfig) {
    IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
    IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
    IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
    return IncludeSSRFeatureFlagsConfig;
}({});

});
parcelRegister("a4Xpq", function(module, exports) {

$parcel$export(module.exports, "MetricState", () => $1466dd6cffc4ce57$export$1e458f18c0c7bfe3);
$parcel$export(module.exports, "PageVisibleState", () => $1466dd6cffc4ce57$export$a12c67b37a306b13);
$parcel$export(module.exports, "BaseMetric", () => $1466dd6cffc4ce57$export$2bce4ffdd840e878);

var $k7jg9 = parcelRequire("k7jg9");

var $iNoUK = parcelRequire("iNoUK");

var $jpJNv = parcelRequire("jpJNv");

var $hOHUD = parcelRequire("hOHUD");
var $1466dd6cffc4ce57$export$1e458f18c0c7bfe3 = /*#__PURE__*/ function(MetricState) {
    MetricState["NOT_STARTED"] = "not-started";
    MetricState["STARTED"] = "started";
    MetricState["FINISHED"] = "finished";
    MetricState["CANCELLED"] = "cancelled";
    return MetricState;
}({});
var $1466dd6cffc4ce57$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["MIXED"] = "mixed";
    PageVisibleState["HIDDEN"] = "hidden";
    return PageVisibleState;
}({});
function $1466dd6cffc4ce57$var$getPageVisibleState() {
    return typeof document !== 'undefined' && document.visibilityState === 'visible' ? "visible" : "hidden";
}
class $1466dd6cffc4ce57$export$2bce4ffdd840e878 {
    static{
        this.FMP = 'fmp';
    }
    constructor(config){
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.onStopCallbacks = [];
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.untilOnStopCallback = null;
        this.pageVisibleState = $1466dd6cffc4ce57$var$getPageVisibleState();
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = "mixed";
        };
        this.config = config;
        this.key = config.key.replace(/ /gi, '-');
        this.type = config.type;
        this.config.timings?.forEach((entry)=>{
            if ((0, $k7jg9.restrictedTimingKeys).includes(entry.key)) {
                // eslint-disable-next-line no-console
                console.warn(`Entry ${entry.key} is restricted and has been renamed to custom__${entry.key}`);
                entry.key = `custom__${entry.key}`;
            }
        });
    }
    get untilMetrics() {
        const { until: until } = this.config;
        if (!until) return [];
        else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
        return this.getConfiguredUntilMetricArray([
            until
        ]);
    }
    start({ startTime: startTime = window.performance.now() } = {}) {
        this.clear();
        (0, $iNoUK.logger).logCond(!!this.config.debug, this.key, startTime);
        this.state = "started";
        this.startTime = startTime;
        this.pageVisibleState = $1466dd6cffc4ce57$var$getPageVisibleState();
        (0, $jpJNv.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
        this.watchUntil();
    }
    stop(stopArguments = {}) {
        const { stopTime: stopTime = window.performance.now() } = stopArguments;
        if (this.state !== "started" || this.startTime === null) {
            (0, $iNoUK.logger).log(`metric ${this.config.key} has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopTime < this.startTime) {
            (0, $iNoUK.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${this.startTime}; stopTime: ${stopTime}`);
            return false;
        }
        this.stopTime = stopTime;
        this.state = "finished";
        this.handleStop(stopArguments);
        (0, $jpJNv.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return true;
    }
    handleStop(stopArguments) {
        const { customData: customData = null } = stopArguments;
        if (customData) this.custom = {
            ...this.custom,
            ...customData
        };
        this.config.include && this.config.include.forEach((metric)=>{
            const included = metric.getData();
            if (included.state === "finished" && included.start !== null && included.start >= (this.startTime || 0)) this.addSubMetric(metric.getData());
        });
        this.onStopCallbacks.forEach(([success])=>{
            success(stopArguments);
        });
        this.onStopCallbacks = [];
        (0, $iNoUK.logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
    }
    mark(mark, timestamp = window.performance.now()) {
        this.marks[mark] = timestamp;
    }
    cancel() {
        if (this.state !== "started") return;
        this.state = "cancelled";
        this.cancelUntil();
        this.onStopCallbacks.forEach(([, cancel])=>{
            cancel();
        });
        this.onStopCallbacks = [];
        (0, $jpJNv.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
    }
    merge(mergeData) {
        this.state = mergeData.state;
        this.pageVisibleState = mergeData.pageVisibleState;
        this.startTime = mergeData.start;
        this.stopTime = mergeData.stop;
        this.marks = {
            ...this.marks,
            ...mergeData.marks
        };
        this.submetrics = [
            ...this.submetrics,
            ...mergeData.submetrics
        ];
        this.onStopCallbacks = [
            ...this.onStopCallbacks,
            ...mergeData.onStopCallbacks
        ];
    }
    onStop(success, cancel) {
        this.onStopCallbacks.push([
            success,
            cancel
        ]);
    }
    removeOnStopCallback(success) {
        const index = this.onStopCallbacks.findIndex(([successCallback])=>{
            return success === successCallback;
        });
        if (index > -1) this.onStopCallbacks.splice(index, 1);
    }
    getData() {
        return {
            key: this.key,
            state: this.state,
            start: this.startTime,
            stop: this.stopTime,
            //todo ranges
            // ranges: this.makeRanges()
            marks: this.marks,
            // todo make copy
            custom: this.custom,
            submetrics: this.submetrics,
            config: this.config,
            route: this.route,
            pageVisibleState: this.pageVisibleState,
            type: this.config.type
        };
    }
    getDataToMerge() {
        return {
            ...this.getData(),
            onStopCallbacks: this.onStopCallbacks
        };
    }
    addSubMetric(data) {
        this.submetrics.push(data);
    }
    /**
	 *
	 * @param metric
	 * The array of Until metrics can be of two types
	 * This function returns an UntilExperience
	 */ getConfiguredUntilMetric(metricOrConfig) {
        return metricOrConfig instanceof $1466dd6cffc4ce57$export$2bce4ffdd840e878 ? (0, $hOHUD.UntilExperience).fromMetric(metricOrConfig) : (0, $hOHUD.UntilExperience).fromConfig(metricOrConfig);
    }
    getConfiguredUntilMetricArray(metricArray) {
        if (!metricArray.length) return [];
        return metricArray.map((metric)=>this.getConfiguredUntilMetric(metric));
    }
    isUntilFinished() {
        return this.untilMetrics.every((metric)=>metric.experience.getData().state === "finished");
    }
    handleAllUntilFinished() {
        // Order by ascending stop time
        const sorted = [
            ...this.untilMetrics
        ].sort((m1, m2)=>{
            return m1.getDependencyStopTime() - m2.getDependencyStopTime();
        });
        // Find the latest page segment to become fully interactive
        const latestFullyInteractiveSegment = [
            ...this.untilMetrics
        ].reduce((currentLatestSegment, metric)=>{
            const currentLatestStopTime = currentLatestSegment?.getFullyInteractiveStopTime() ?? 0;
            const metricStopTime = metric.getFullyInteractiveStopTime() ?? 0;
            return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
        }, undefined);
        // Accumulate the custom data from each metric, later metrics take priority
        const accumulatedCustomData = {};
        sorted.forEach((metric)=>{
            Object.assign(accumulatedCustomData, metric.experience.getData().custom);
        });
        const latestSegment = sorted[sorted.length - 1];
        const latestFullyInteractiveStopTime = latestFullyInteractiveSegment?.getFullyInteractiveStopTime();
        this.stop({
            stopTime: latestSegment.getDependencyStopTime(),
            customData: {
                ...accumulatedCustomData,
                segment: latestSegment.getKey(),
                segmentOverrided: latestSegment.getIsSegmentLoadOverrided(),
                ...latestFullyInteractiveStopTime ? {
                    latestFullyInteractiveSegment: latestFullyInteractiveSegment?.getKey(),
                    latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                } : {}
            }
        });
    }
    watchUntil() {
        if (!this.untilMetrics.length) return;
        if (this.isUntilFinished()) {
            // Already finished, handle it immediately
            this.handleAllUntilFinished();
            return;
        }
        // If not currently finished, register stop callbacks to re-check
        this.untilOnStopCallback = ()=>{
            if (this.isUntilFinished()) this.handleAllUntilFinished();
        };
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "finished") metric.experience.onStop(this.untilOnStopCallback, ()=>this.cancel());
        });
    }
    cancelUntil() {
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "cancelled" && this.untilOnStopCallback) metric.experience.removeOnStopCallback(this.untilOnStopCallback);
        });
    }
    clear() {
        // todo before clearing - handle cancelling existing onStop / unsubscribe submetrics
        this.cancelUntil();
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.pageVisibleState = $1466dd6cffc4ce57$var$getPageVisibleState();
    }
}

});
parcelRegister("k7jg9", function(module, exports) {

$parcel$export(module.exports, "restrictedTimingKeys", () => $270a04c2e83e3633$export$1d17377365286b00);
$parcel$export(module.exports, "clsWaitTimeMs", () => $270a04c2e83e3633$export$df21d285cfcda81e);
const $270a04c2e83e3633$export$1d17377365286b00 = [
    'ssr'
];
const $270a04c2e83e3633$export$df21d285cfcda81e = 7500;

});

parcelRegister("jpJNv", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $94b1dace658bfb31$export$13e680397ec8f3eb);
class $94b1dace658bfb31$var$VisibilityChangeObserver {
    start() {
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $94b1dace658bfb31$export$13e680397ec8f3eb = new $94b1dace658bfb31$var$VisibilityChangeObserver();

});

parcelRegister("hOHUD", function(module, exports) {

$parcel$export(module.exports, "UntilExperience", () => $567a43560299606e$export$3fcc0936ee2cc852);
class $567a43560299606e$export$3fcc0936ee2cc852 {
    static{
        this.FMP = 'fmp';
    }
    static fromConfig(config) {
        return new $567a43560299606e$export$3fcc0936ee2cc852(config.experience, config.useFmpAsUntilStopTime);
    }
    static fromMetric(metric) {
        return new $567a43560299606e$export$3fcc0936ee2cc852(metric);
    }
    constructor(experience, useFmpAsUntilStopTime){
        this.experience = experience;
        this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
    }
    /**
	 * If FMP mark is present, return that
	 * otherwise return the eventual load
	 */ getFmp() {
        const { marks: marks, stop: stop } = this.experience.getData();
        return marks[$567a43560299606e$export$3fcc0936ee2cc852.FMP] ?? stop;
    }
    getDependencyStopTime() {
        if (this.useFmpAsUntilStopTime) return this.getFmp();
        return this.experience.getData().stop;
    }
    /**
	 * Get the time it takes for a segment to become fully interactable,
	 * regardless of whether it uses the FMP as the stop time. (Eventual load)
	 */ getFullyInteractiveStopTime() {
        return this.experience.getData().stop;
    }
    getIsSegmentLoadOverrided() {
        if (this.useFmpAsUntilStopTime) {
            const { marks: marks } = this.experience.getData();
            return marks[$567a43560299606e$export$3fcc0936ee2cc852.FMP] ? true : false;
        }
        return false;
    }
    getKey() {
        return this.experience.getData().key;
    }
}

});



parcelRegister("dxIdG", function(module, exports) {

$parcel$export(module.exports, "BasePageLoadMetric", () => $c4476fbcb8b62a60$export$fd1447b187f590fe);

var $iNoUK = parcelRequire("iNoUK");

var $a4Xpq = parcelRequire("a4Xpq");
class $c4476fbcb8b62a60$export$fd1447b187f590fe extends (0, $a4Xpq.BaseMetric) {
    static{
        this.FMP = 'fmp';
    }
    constructor(args){
        super(args), this.isInitial = true, this.explicitTimings = null;
        this.config = args;
    }
    start({} = {}) {
        // please use startPageLoad
        return;
    }
    startPageLoad(params = {
        isInitial: false
    }) {
        // todo this should update meta page load metric
        this.isInitial = params.isInitial;
        if (params.isInitial) super.start({
            startTime: 0
        });
        else super.start(params);
        (0, $iNoUK.logger).logCond(!!this.config.debug, this.key, this.startTime);
    }
    stopPageLoad(pageLoadMetaMetricData, stopArguments = {
        stopTime: window.performance.now()
    }) {
        if (pageLoadMetaMetricData.state !== (0, $a4Xpq.MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
            (0, $iNoUK.logger).log(`meta metric has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
            (0, $iNoUK.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${pageLoadMetaMetricData.start}; stopTime: ${stopArguments.stopTime}`);
            return false;
        }
        this.merge(pageLoadMetaMetricData);
        this.stopTime = stopArguments.stopTime;
        this.state = (0, $a4Xpq.MetricState).FINISHED;
        this.handleStop(stopArguments);
        return true;
    }
    handleStop(stopArguments) {
        const { until: until } = this.config;
        const fmpWasMarked = $c4476fbcb8b62a60$export$fd1447b187f590fe.FMP in this.marks;
        if (!fmpWasMarked && until) {
            // Extract the maximum FMP value from the until metrics
            const untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                until
            ]);
            const untilFmpMarks = untilArr.map((metric)=>metric.getFmp());
            if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max(...untilFmpMarks));
        }
        super.handleStop(stopArguments);
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $c4476fbcb8b62a60$export$fd1447b187f590fe.FMP) return;
        super.mark(mark, timestamp);
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
        this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? {
            ...mergeData.explicitTimings,
            ...this.explicitTimings
        } : null;
    }
    markFMP(timestamp) {
        super.mark($c4476fbcb8b62a60$export$fd1447b187f590fe.FMP, timestamp);
    }
    getPageLoadData() {
        return {
            isInitial: this.isInitial,
            explicitTimings: this.explicitTimings
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageLoadData()
        };
    }
    clear() {
        this.explicitTimings = null;
        super.clear();
    }
}

});


parcelRegister("fdKY9", function(module, exports) {

$parcel$export(module.exports, "webVitalsObserver", () => $91a62c084dcf5029$export$253d38dccbb37615);


class $91a62c084dcf5029$var$WebVitalsObserver {
    start() {
        this.ttciDetermined = this.registerTTCI();
        this.webVitalsDetermined = this.registerWebVitals();
    }
    async registerWebVitals() {
        try {
            const { getCLS: getCLS, getFCP: getFCP, getFID: getFID, getLCP: getLCP, getTTFB: getTTFB } = await (parcelRequire("4EeuU"));
            await Promise.all([
                getTTFB,
                getFID,
                getFCP,
                getLCP,
                getCLS
            ].map((fx)=>new Promise((resolve)=>{
                    fx(({ name: name, value: value })=>{
                        // round FCP, FID, LCP, TTFB to nearest integer.
                        // CLS is rounded to two decimal places.
                        const metricName = name.toLowerCase();
                        const metricValue = metricName === 'cls' ? parseFloat(value.toFixed(2)) : Math.round(value);
                        this.data[`metric:${metricName}`] = metricValue;
                        resolve();
                    });
                })));
        } catch (e) {}
    }
    async registerTTCI() {
        try {
            const ttiPolyfill = await (parcelRequire("fRY4k"));
            await ttiPolyfill.getFirstConsistentlyInteractive().then((value)=>{
                // according to the docs:
                // If no TTI value can be found, or if the browser doesn't support all the APIs required to detect TTI,
                // the promise resolves to null.
                this.data['metric:ttci'] = typeof value === 'number' ? Math.round(value) : value;
                return true;
            });
        } catch (e) {}
    }
    constructor(){
        this.data = {
            'metric:ttci': null,
            'metric:ttfb': null,
            'metric:fid': null,
            'metric:fcp': null,
            'metric:lcp': null,
            'metric:cls': null
        };
    }
}
const $91a62c084dcf5029$export$253d38dccbb37615 = new $91a62c084dcf5029$var$WebVitalsObserver();

});
parcelRegister("4EeuU", function(module, exports) {

let $362624c2ea09782a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $362624c2ea09782a$var$load("gceFf").then(()=>parcelRequire('gDSxx'));

});
parcelRegister("28QjX", function(module, exports) {
"use strict";


var $18f4e9fbd43d4c3b$var$load = function(maxShards) {
    return function(id) {
        // eslint-disable-next-line no-undef
        return import((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve(id), maxShards));
    };
};
module.exports = $18f4e9fbd43d4c3b$var$load;

});
parcelRegister("kPuw4", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2, (v) => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $f2a03df3e93d4e79$export$2bf9932c19d6a5d2;
var $f2a03df3e93d4e79$export$1d37a31d51d1e3ed;
var $f2a03df3e93d4e79$export$b4cd98d62f81485f;
var $f2a03df3e93d4e79$export$108ff8fc702e621f;
var $f2a03df3e93d4e79$export$f6f4188f9108e61;
"use strict";
let $f2a03df3e93d4e79$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $f2a03df3e93d4e79$var$getDomainShardIndex(str, maxShards) {
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << maxShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % maxShards;
    // Make number positive
    if (shard < 0) shard += maxShards;
    return shard;
}
let $f2a03df3e93d4e79$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $f2a03df3e93d4e79$var$removeTrailingShard(subdomain) {
    if (!$f2a03df3e93d4e79$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $f2a03df3e93d4e79$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // Domains like localhost have no . separators
    if (i === -1) return `${$f2a03df3e93d4e79$var$removeTrailingShard(domain)}-${shard}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $f2a03df3e93d4e79$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}-${shard}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $f2a03df3e93d4e79$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $f2a03df3e93d4e79$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $f2a03df3e93d4e79$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$f2a03df3e93d4e79$var$globalKeyName]) return url;
    return $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards);
}
$f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = $f2a03df3e93d4e79$var$shardUrl;
$f2a03df3e93d4e79$export$1d37a31d51d1e3ed = $f2a03df3e93d4e79$var$shardUrlUnchecked;
$f2a03df3e93d4e79$export$b4cd98d62f81485f = $f2a03df3e93d4e79$var$getDomainShardIndex;
$f2a03df3e93d4e79$export$108ff8fc702e621f = $f2a03df3e93d4e79$var$applyShardToDomain;
$f2a03df3e93d4e79$export$f6f4188f9108e61 = $f2a03df3e93d4e79$var$globalKeyName;

});

parcelRegister("dy9lH", function(module, exports) {

$parcel$export(module.exports, "register", () => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf, (v) => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $9dd5b3e06d7b5702$export$f7ad0328861e2f03, (v) => $9dd5b3e06d7b5702$export$f7ad0328861e2f03 = v);
var $9dd5b3e06d7b5702$export$6503ec6e8aabbaf;
var $9dd5b3e06d7b5702$export$f7ad0328861e2f03;
"use strict";
var $9dd5b3e06d7b5702$var$mapping = new Map();
function $9dd5b3e06d7b5702$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$9dd5b3e06d7b5702$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $9dd5b3e06d7b5702$var$resolve(id) {
    var resolved = $9dd5b3e06d7b5702$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$9dd5b3e06d7b5702$export$6503ec6e8aabbaf = $9dd5b3e06d7b5702$var$register;
$9dd5b3e06d7b5702$export$f7ad0328861e2f03 = $9dd5b3e06d7b5702$var$resolve;

});



parcelRegister("fRY4k", function(module, exports) {

let $b8da66aad20ee1ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b8da66aad20ee1ca$var$load("8qy0v").then(()=>parcelRequire('8yzun'));

});


parcelRegister("ffpPO", function(module, exports) {

$parcel$export(module.exports, "Route", () => $06ac53729f899dac$export$e7b0ac011bb776c6);
const $06ac53729f899dac$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});

parcelRegister("jNWGz", function(module, exports) {

$parcel$export(module.exports, "submitter", () => $f10ba2fe4c3bd70a$export$c21a25872e3f5a2b);

var $6V56P = parcelRequire("6V56P");

var $2n5zh = parcelRequire("2n5zh");

var $jddjt = parcelRequire("jddjt");

var $bq6vn = parcelRequire("bq6vn");
const $f10ba2fe4c3bd70a$export$c21a25872e3f5a2b = {
    debug: false,
    config: {
        gasv3: undefined,
        configChunk: null,
        useVisibleState: false,
        histogram: {},
        enableReactUFOTracker: false
    },
    configure (config) {
        this.config.gasv3 = config.endpoints.eventPipelineClient;
        this.config.enableReactUFOTracker = config.enableReactUFOTracker;
        this.config.configChunk = (0, $bq6vn.makeShareableGlobalConfig)(config);
        if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, $2n5zh.PageVisibleFields).pageVisibleState;
    },
    setDebug (debug) {
        this.debug = debug;
    },
    async queue (data) {
        if (this.config.enableReactUFOTracker) (0, $6V56P.addBrowserMetricEvent)(data);
        if (!this.config.configChunk) {
            // eslint-disable-next-line no-console
            this.debug && console.warn('Submitter is not configured');
            return null;
        }
        const chunk = await this.config.configChunk;
        const payload = await (0, $jddjt.eventDataProcessor)(chunk[data.config.type], data);
        if (payload === null) return;
        if (this.config.gasv3 !== undefined) {
            const client = await this.config.gasv3;
            const attributes = {
                task: payload['event:key'],
                properties: payload
            };
            client && client.sendOperationalEvent({
                actionSubject: 'performance',
                attributes: attributes,
                source: 'performance',
                action: 'measured'
            });
        }
    }
};

});
parcelRegister("jddjt", function(module, exports) {

$parcel$export(module.exports, "eventDataProcessor", () => $77b4870085cefc7e$export$896b6e121bbaec25);

var $k7jg9 = parcelRequire("k7jg9");

var $iNoUK = parcelRequire("iNoUK");

var $9CNqE = parcelRequire("9CNqE");

var $lQhVm = parcelRequire("lQhVm");

var $5fVpH = parcelRequire("5fVpH");

var $5cXnV = parcelRequire("5cXnV");

var $axPxi = parcelRequire("axPxi");

var $8iRMW = parcelRequire("8iRMW");

var $cFt3p = parcelRequire("cFt3p");

var $7ubws = parcelRequire("7ubws");

var $Za98p = parcelRequire("Za98p");

var $1GFqB = parcelRequire("1GFqB");

var $8g0ES = parcelRequire("8g0ES");

var $1zqV3 = parcelRequire("1zqV3");

var $d8seU = parcelRequire("d8seU");

var $iQ3Ri = parcelRequire("iQ3Ri");

var $209D8 = parcelRequire("209D8");

var $9sJXH = parcelRequire("9sJXH");

var $upZhz = parcelRequire("upZhz");

var $6jTqB = parcelRequire("6jTqB");

var $krRAh = parcelRequire("krRAh");

var $hQMlN = parcelRequire("hQMlN");

var $lSoZt = parcelRequire("lSoZt");

var $4hBt6 = parcelRequire("4hBt6");

var $1A0CZ = parcelRequire("1A0CZ");

var $3BGDk = parcelRequire("3BGDk");

var $aTi94 = parcelRequire("aTi94");

var $hwBrS = parcelRequire("hwBrS");

var $g5ZHz = parcelRequire("g5ZHz");

var $3uwOU = parcelRequire("3uwOU");

var $l1DMD = parcelRequire("l1DMD");

var $4iKEF = parcelRequire("4iKEF");

var $4vxQk = parcelRequire("4vxQk");

var $eTYgb = parcelRequire("eTYgb");

var $bMb3e = parcelRequire("bMb3e");

var $kgkCZ = parcelRequire("kgkCZ");

var $2n5zh = parcelRequire("2n5zh");
const $77b4870085cefc7e$var$defaultSet = [
    (0, $7ubws.eventKey),
    (0, $d8seU.eventType),
    (0, $1GFqB.eventProduct),
    (0, $1zqV3.eventRoute),
    (0, $8iRMW.eventId),
    (0, $Za98p.eventLocalTime),
    (0, $8g0ES.eventRegion),
    (0, $lQhVm.appFramework),
    (0, $5fVpH.appVersion),
    (0, $5cXnV.bmVersion),
    (0, $3uwOU.telemetryBrowser),
    (0, $l1DMD.telemetryCpu),
    (0, $4iKEF.telemetryMemory),
    (0, $4vxQk.telemetryNetwork),
    (0, $axPxi.customData),
    (0, $iQ3Ri.featureFlags),
    (0, $209D8.hostname),
    (0, $aTi94.productCustomData),
    (0, $eTYgb.appTimings),
    (0, $kgkCZ.resourceTimings)
];
const $77b4870085cefc7e$var$pageLoadCommon = [
    ...$77b4870085cefc7e$var$defaultSet,
    (0, $1A0CZ.pageVisibleState),
    (0, $3BGDk.pageVisibleValue),
    (0, $cFt3p.eventInitial),
    (0, $hQMlN.pageLoadMetrics),
    (0, $bMb3e.bundleEvalTimings)
];
const $77b4870085cefc7e$var$initialPageLoadSet = [
    ...$77b4870085cefc7e$var$pageLoadCommon,
    (0, $upZhz.initialPageLoadMetrics),
    (0, $krRAh.navigationMetrics),
    (0, $g5ZHz.ssrSuccess),
    (0, $hwBrS.ssrFeatureFlags)
];
const $77b4870085cefc7e$var$spaTransitionSet = [
    ...$77b4870085cefc7e$var$pageLoadCommon
];
const $77b4870085cefc7e$var$pageSegmentLoadSet = [
    ...$77b4870085cefc7e$var$defaultSet,
    (0, $lSoZt.pageSegmentLoadMetrics),
    (0, $1A0CZ.pageVisibleState),
    (0, $3BGDk.pageVisibleValue),
    (0, $cFt3p.eventInitial),
    (0, $bMb3e.bundleEvalTimings)
];
const $77b4870085cefc7e$var$interactionSet = [
    ...$77b4870085cefc7e$var$defaultSet,
    (0, $1A0CZ.pageVisibleState),
    (0, $3BGDk.pageVisibleValue),
    (0, $6jTqB.interactionMetrics)
];
const $77b4870085cefc7e$var$customMetricSet = [
    ...$77b4870085cefc7e$var$defaultSet,
    (0, $1A0CZ.pageVisibleState),
    (0, $3BGDk.pageVisibleValue),
    (0, $9sJXH.customEventMetrics)
];
// pageVisibleState and pageVisibleValue has been handled within webVitalsMetrics.
const $77b4870085cefc7e$var$webVitalsMetricSet = [
    ...$77b4870085cefc7e$var$defaultSet,
    (0, $4hBt6.webVitalsMetrics)
];
// Function that returns a promise which resolves after clsWaitTimeMs + 500ms
// so that clsData is guaranteed to be attached to window
const $77b4870085cefc7e$var$waitForCLS = (delay = (0, $k7jg9.clsWaitTimeMs) + 500)=>{
    return new Promise((resolve)=>setTimeout(resolve, delay));
};
const $77b4870085cefc7e$export$896b6e121bbaec25 = async (globalConfig, data)=>{
    if (data.start === null || data.stop === null) {
        (0, $iNoUK.logger).log(`eventDataProcessor: Metric "${data.key}" start or stop are incorrect; start: ${data.start}; stop: ${data.stop}`);
        return null;
    }
    let set = [];
    if (data.config.type === (0, $2n5zh.BMEventsType).PAGE_LOAD && (0, $9CNqE.isPageLoadMetricData)(data) && data.isInitial) set = $77b4870085cefc7e$var$initialPageLoadSet;
    if (data.config.type === (0, $2n5zh.BMEventsType).PAGE_LOAD && (0, $9CNqE.isPageLoadMetricData)(data) && !data.isInitial) set = $77b4870085cefc7e$var$spaTransitionSet;
    if (data.config.type === (0, $2n5zh.BMEventsType).PAGE_SEGMENT_LOAD && (0, $9CNqE.isPageSegmentLoadMetricData)(data)) set = $77b4870085cefc7e$var$pageSegmentLoadSet;
    if (data.config.type === (0, $2n5zh.BMEventsType).INLINE_RESULT) set = $77b4870085cefc7e$var$interactionSet;
    if (data.config.type === (0, $2n5zh.BMEventsType).CUSTOM) set = $77b4870085cefc7e$var$customMetricSet;
    if (data.config.type === (0, $2n5zh.BMEventsType).WEB_VITALS) {
        set = $77b4870085cefc7e$var$webVitalsMetricSet;
        // Wait for CLS to be recorded before proceeding to run plugin and attach CLS data
        await $77b4870085cefc7e$var$waitForCLS();
    }
    //TODO if type is different - do not send at all
    const plugins = [];
    for (const plugin of set){
        const result = await plugin(data.config, data, globalConfig);
        if (result) plugins.push(result);
    }
    const pluginResults = await Promise.all(plugins);
    const generated = {};
    pluginResults.forEach((pluginResult)=>{
        if (pluginResult === null) return;
        Object.keys(pluginResult).forEach((key)=>{
            const keyResult = pluginResult[key];
            if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
        });
    });
    return generated;
};

});
parcelRegister("9CNqE", function(module, exports) {

$parcel$export(module.exports, "isPageLoadMetricData", () => $1335aba64dfd2eee$export$b0e12e7abb0bff11);
$parcel$export(module.exports, "isPageSegmentLoadMetricData", () => $1335aba64dfd2eee$export$83d0099ee6dbb5b0);
$parcel$export(module.exports, "isPageLoadConfig", () => $1335aba64dfd2eee$export$8672fa27ba8bba88);
$parcel$export(module.exports, "isPageSegmentLoadConfig", () => $1335aba64dfd2eee$export$abe063537ef4987b);
$parcel$export(module.exports, "isInteractionConfig", () => $1335aba64dfd2eee$export$ae68674b6a9353be);
$parcel$export(module.exports, "isCustomConfig", () => $1335aba64dfd2eee$export$b493eb8b2ba87421);

var $2n5zh = parcelRequire("2n5zh");
const $1335aba64dfd2eee$export$b0e12e7abb0bff11 = (data)=>{
    return data.type === (0, $2n5zh.BMEventsType).PAGE_LOAD;
};
const $1335aba64dfd2eee$export$83d0099ee6dbb5b0 = (data)=>{
    return data.type === (0, $2n5zh.BMEventsType).PAGE_SEGMENT_LOAD;
};
const $1335aba64dfd2eee$export$8672fa27ba8bba88 = (data)=>{
    return data.type === (0, $2n5zh.BMEventsType).PAGE_LOAD;
};
const $1335aba64dfd2eee$export$abe063537ef4987b = (data)=>{
    return data.type === (0, $2n5zh.BMEventsType).PAGE_SEGMENT_LOAD;
};
const $1335aba64dfd2eee$export$ae68674b6a9353be = (data)=>{
    return data.type === (0, $2n5zh.BMEventsType).INLINE_RESULT;
};
const $1335aba64dfd2eee$export$b493eb8b2ba87421 = (data)=>{
    return data.type === (0, $2n5zh.BMEventsType).CUSTOM;
};

});

parcelRegister("lQhVm", function(module, exports) {

$parcel$export(module.exports, "appFramework", () => $1dcadfe326d1e52d$export$e34e4529b979f74c);
const $1dcadfe326d1e52d$export$e34e4529b979f74c = (_config, _data, globalConfig)=>{
    if (!globalConfig.app.framework) return null;
    return {
        'app:framework:name': globalConfig.app.framework.name,
        'app:framework:version': globalConfig.app.framework.version
    };
};

});

parcelRegister("5fVpH", function(module, exports) {

$parcel$export(module.exports, "appVersion", () => $f7330c0423f8f031$export$82ae485178b37419);
const $f7330c0423f8f031$export$82ae485178b37419 = (_config, _data, globalConfig)=>{
    const pluginData = {
        'app:web:version': globalConfig.app.version.web
    };
    if (globalConfig.app.version.ssr) pluginData['app:ssr:version'] = globalConfig.app.version.ssr;
    return pluginData;
};

});

parcelRegister("5cXnV", function(module, exports) {

$parcel$export(module.exports, "bmVersion", () => $f9a36daf760c454b$export$5cafa465fc876895);
const $f9a36daf760c454b$export$5cafa465fc876895 = ()=>{
    return {
        'bm:version': 3
    };
};

});

parcelRegister("axPxi", function(module, exports) {

$parcel$export(module.exports, "customData", () => $96abb43b767cb332$export$f7e743c7db162193);
const $96abb43b767cb332$export$f7e743c7db162193 = (_config, data)=>{
    const custom = {};
    let changed = false;
    if (data.custom) Object.entries(data.custom).forEach(([key, value])=>{
        changed = true;
        custom[`custom:${key}`] = value;
    });
    return changed ? custom : null;
};

});

parcelRegister("8iRMW", function(module, exports) {

$parcel$export(module.exports, "eventId", () => $9a69e5e0ce41075c$export$aed28df7ac07d79a);
const $9a69e5e0ce41075c$export$aed28df7ac07d79a = (config)=>{
    return {
        'event:id': config.key
    };
};

});

parcelRegister("cFt3p", function(module, exports) {

$parcel$export(module.exports, "eventInitial", () => $31ac737d5d55192d$export$fa8e91d436b3ef8b);

var $9CNqE = parcelRequire("9CNqE");
const $31ac737d5d55192d$export$fa8e91d436b3ef8b = (_config, data)=>{
    if (!(0, $9CNqE.isPageLoadMetricData)(data) && !(0, $9CNqE.isPageSegmentLoadMetricData)(data)) return null;
    return {
        'event:initial': data.isInitial
    };
};

});

parcelRegister("7ubws", function(module, exports) {

$parcel$export(module.exports, "eventKey", () => $dd0927dfdf3c2c98$export$10be2d3a558d3f88);

var $eyo5G = parcelRequire("eyo5G");
const $dd0927dfdf3c2c98$export$10be2d3a558d3f88 = (config, _data, globalConfig)=>{
    return {
        'event:key': `${globalConfig.product}.fe.${(0, $eyo5G.mapEventType)(config.type)}.${config.key}`
    };
};

});
parcelRegister("eyo5G", function(module, exports) {

$parcel$export(module.exports, "mapEventType", () => $13694551def79c5a$export$b334d07f11140768);

var $2n5zh = parcelRequire("2n5zh");
const $13694551def79c5a$export$b334d07f11140768 = (type)=>{
    switch(type){
        case (0, $2n5zh.BMEventsType).CUSTOM:
            return (0, $2n5zh.StorableBMEventsType).CUSTOM;
        case (0, $2n5zh.BMEventsType).INLINE_RESULT:
            return (0, $2n5zh.StorableBMEventsType).INLINE_RESULT;
        case (0, $2n5zh.BMEventsType).PAGE_LOAD:
            return (0, $2n5zh.StorableBMEventsType).PAGE_LOAD;
        case (0, $2n5zh.BMEventsType).PAGE_SEGMENT_LOAD:
            return (0, $2n5zh.StorableBMEventsType).PAGE_SEGMENT_LOAD;
        case (0, $2n5zh.BMEventsType).WEB_VITALS:
            return (0, $2n5zh.StorableBMEventsType).WEB_VITALS;
        default:
            return 'unknown';
    }
};

});


parcelRegister("Za98p", function(module, exports) {

$parcel$export(module.exports, "eventLocalTime", () => $bc01858635b9269f$export$5219854ae7ec45da);

var $k7m40 = parcelRequire("k7m40");
const $bc01858635b9269f$export$5219854ae7ec45da = ()=>({
        'event:localHour': parseInt((0, $k7m40.default)(new Date(), 'H'), 10),
        'event:localDayOfWeek': parseInt((0, $k7m40.default)(new Date(), 'i'), 10)
    });

});

parcelRegister("1GFqB", function(module, exports) {

$parcel$export(module.exports, "eventProduct", () => $350af855c7625fe8$export$a7df4e8088db8843);
const $350af855c7625fe8$export$a7df4e8088db8843 = (_config, _data, globalConfig)=>{
    return {
        'event:product': `${globalConfig.product}`
    };
};

});

parcelRegister("8g0ES", function(module, exports) {

$parcel$export(module.exports, "eventRegion", () => $9ec5ac4b28ea50ac$export$d0117b71adcdebc0);
const $9ec5ac4b28ea50ac$export$d0117b71adcdebc0 = (_config, _data, globalConfig)=>{
    return {
        'event:region': `${globalConfig.region}`
    };
};

});

parcelRegister("1zqV3", function(module, exports) {

$parcel$export(module.exports, "eventRoute", () => $dd8bdcddf8479fa2$export$44d3627af289ca16);
const $dd8bdcddf8479fa2$export$44d3627af289ca16 = (_config, data)=>{
    if (!data.route) return null;
    return {
        'event:route': data.route
    };
};

});

parcelRegister("d8seU", function(module, exports) {

$parcel$export(module.exports, "eventType", () => $f52476982974644c$export$4c045e605d532c98);

var $eyo5G = parcelRequire("eyo5G");
const $f52476982974644c$export$4c045e605d532c98 = (config)=>{
    return {
        'event:type': (0, $eyo5G.mapEventType)(config.type)
    };
};

});

parcelRegister("iQ3Ri", function(module, exports) {

$parcel$export(module.exports, "featureFlags", () => $f967f4e6a637bd55$export$e62953d023125748);
const $f967f4e6a637bd55$export$e62953d023125748 = (config, _data, globalConfig)=>{
    const localFeatureFlags = config.featureFlags?.reduce((acc, ffName)=>{
        acc[ffName] = globalConfig.ffClient.getValue(ffName);
        return acc;
    }, {}) || null;
    if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
    return {
        featureFlags: {
            ...localFeatureFlags,
            ...globalConfig.featureFlags
        }
    };
};

});

parcelRegister("209D8", function(module, exports) {

$parcel$export(module.exports, "hostname", () => $d37dac8536b83f28$export$640106f6dc7d2706);
const $d37dac8536b83f28$export$640106f6dc7d2706 = (_config, _data, globalConfig)=>{
    return {
        hostname: globalConfig.hostname
    };
};

});

parcelRegister("9sJXH", function(module, exports) {

$parcel$export(module.exports, "customEventMetrics", () => $06afd139a28693b1$export$cab039265c52a2e9);

var $9CNqE = parcelRequire("9CNqE");
const $06afd139a28693b1$export$cab039265c52a2e9 = (config, data, globalConfig)=>{
    if (!(0, $9CNqE.isCustomConfig)(config)) return null;
    const payload = {
        'metric:duration': Math.round(data.stop - data.start)
    };
    if (config.slo?.threshold !== undefined) {
        payload['metric:duration:slo'] = payload['metric:duration'] <= config.slo?.threshold;
        payload['metric:duration:slo:threshold'] = config.slo?.threshold;
    }
    if (config.histogram?.duration) payload['metric:duration:histogramBuckets'] = config.histogram.duration;
    else if (globalConfig.histogram) payload['metric:duration:histogramBuckets'] = globalConfig.histogram.duration;
    return payload;
};

});

parcelRegister("upZhz", function(module, exports) {

$parcel$export(module.exports, "initialPageLoadMetrics", () => $53d651de1fc23fcf$export$cc95aa3f6ea8e5cb);
const $53d651de1fc23fcf$export$cc95aa3f6ea8e5cb = ()=>{
    const metrics = {};
    performance.getEntriesByType('paint').forEach((entry)=>{
        if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
    });
    return metrics;
};

});

parcelRegister("6jTqB", function(module, exports) {

$parcel$export(module.exports, "interactionMetrics", () => $4105614e46c67449$export$86db56030b57ba34);

var $9CNqE = parcelRequire("9CNqE");

var $2n5zh = parcelRequire("2n5zh");
const $4105614e46c67449$export$86db56030b57ba34 = (config, data, globalConfig)=>{
    if (!(0, $9CNqE.isInteractionConfig)(config)) return null;
    const result = {
        'metric:result': Math.round(data.stop - data.start)
    };
    if (config.histogram?.result) result['metric:result:histogramBuckets'] = config.histogram.result;
    else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        if (histogram.result !== undefined) result['metric:result:histogramBuckets'] = histogram[(0, $2n5zh.BMInteractionMetrics).result];
    }
    if (config.slo && (0, $2n5zh.isInteractionMetricsSlo)(config.slo) && config.slo.result) {
        result['metric:result:slo'] = result['metric:result'] <= config.slo.result.threshold;
        result['metric:result:slo:threshold'] = config.slo.result.threshold;
    }
    if (data.marks['feedback']) {
        result['metric:response'] = Math.round((data.marks['feedback'] || data.stop) - data.start);
        if (config.histogram?.response) result['metric:response:histogramBuckets'] = config.histogram[(0, $2n5zh.BMInteractionMetrics).response];
        else if (globalConfig.histogram) {
            const histogram = globalConfig.histogram;
            if (histogram.result !== undefined) result['metric:response:histogramBuckets'] = histogram[(0, $2n5zh.BMInteractionMetrics).response];
        }
        if (config.slo && (0, $2n5zh.isInteractionMetricsSlo)(config.slo) && config.slo.response) {
            result['metric:response:slo'] = result['metric:response'] <= config.slo.response.threshold;
            result['metric:response:slo:threshold'] = config.slo.response.threshold;
        }
    }
    return result;
};

});

parcelRegister("krRAh", function(module, exports) {

$parcel$export(module.exports, "navigationMetrics", () => $1e298b5de469b79a$export$b88d990436be0f8a);
const $1e298b5de469b79a$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("hQMlN", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetrics", () => $a915cc8a37e217dd$export$2878bf482e539059);

var $9CNqE = parcelRequire("9CNqE");

var $2n5zh = parcelRequire("2n5zh");
const $a915cc8a37e217dd$var$getThreshold = (isInitial, metric)=>{
    return (0, $2n5zh.isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $a915cc8a37e217dd$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $a915cc8a37e217dd$export$2878bf482e539059 = (config, data, globalConfig)=>{
    if (!(0, $9CNqE.isPageLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page load data for non-page-load config');
    const fmp = data.marks[(0, $2n5zh.BMPageLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $a915cc8a37e217dd$var$getHistogram(data.isInitial, (0, $2n5zh.BMPageLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $a915cc8a37e217dd$var$getHistogram(data.isInitial, (0, $2n5zh.BMPageLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $a915cc8a37e217dd$var$getHistogram(data.isInitial, (0, $2n5zh.BMPageLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $a915cc8a37e217dd$var$getHistogram(data.isInitial, (0, $2n5zh.BMPageLoadMetrics).tti, histogram);
    }
    if (config.slo && config.slo.fmp) {
        const threshold = $a915cc8a37e217dd$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo && config.slo.tti) {
        const threshold = $a915cc8a37e217dd$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    return result;
};

});

parcelRegister("lSoZt", function(module, exports) {

$parcel$export(module.exports, "pageSegmentLoadMetrics", () => $02475cf74774d19e$export$ba86cb47f2f22db5);

var $hIyDI = parcelRequire("hIyDI");

var $9CNqE = parcelRequire("9CNqE");

var $2n5zh = parcelRequire("2n5zh");
const $02475cf74774d19e$var$getThreshold = (isInitial, metric)=>{
    return (0, $2n5zh.isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $02475cf74774d19e$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $02475cf74774d19e$export$ba86cb47f2f22db5 = (config, data, globalConfig)=>{
    if (!(0, $9CNqE.isPageSegmentLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page segment load data for non-page-segment-load config');
    const fmp = data.marks[(0, $2n5zh.BMPageSegmentLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $02475cf74774d19e$var$getHistogram(data.isInitial, (0, $2n5zh.BMPageSegmentLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $02475cf74774d19e$var$getHistogram(data.isInitial, (0, $2n5zh.BMPageSegmentLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $02475cf74774d19e$var$getHistogram(data.isInitial, (0, $2n5zh.BMPageSegmentLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $02475cf74774d19e$var$getHistogram(data.isInitial, (0, $2n5zh.BMPageSegmentLoadMetrics).tti, histogram);
    }
    if (config.slo?.fmp) {
        const threshold = $02475cf74774d19e$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo?.tti) {
        const threshold = $02475cf74774d19e$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    if (config.includePageLoadTimings === (0, $2n5zh.PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, $2n5zh.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
        const pageLoadData = (0, $hIyDI.pageLoadMetaMetric).getData();
        const fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, $2n5zh.BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
        const tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
        result['pageLoad'] = {
            fmp: fmp,
            tti: tti
        };
    }
    return result;
};

});

parcelRegister("4hBt6", function(module, exports) {

$parcel$export(module.exports, "webVitalsMetrics", () => $efc35166653b64f9$export$3731db279f590f30);

var $a4Xpq = parcelRequire("a4Xpq");

var $jpJNv = parcelRequire("jpJNv");

var $fdKY9 = parcelRequire("fdKY9");

var $3BGDk = parcelRequire("3BGDk");
const $efc35166653b64f9$export$3731db279f590f30 = async (config, data, globalConfig)=>{
    let pageVisibleState = data.pageVisibleState;
    const setPageVisibleStateToMixed = ()=>{
        pageVisibleState = (0, $a4Xpq.PageVisibleState).MIXED;
    };
    (0, $jpJNv.visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
    const ttciEnabled = globalConfig.webVitals?.ttciEnabled !== undefined ? globalConfig.webVitals?.ttciEnabled : true;
    const webVitalMetrics = await $efc35166653b64f9$export$193ae490b52081dd(ttciEnabled, globalConfig.webVitals?.timeout || 30000);
    (0, $jpJNv.visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
    return {
        ...webVitalMetrics,
        'pageVisible:state': pageVisibleState,
        ...(0, $3BGDk.pageVisibleValue)(config, data, globalConfig)
    };
};
const $efc35166653b64f9$export$193ae490b52081dd = async (ttciEnabled, timeout)=>{
    // wait for webVitalsObserver.ttciDetermined if ttciEnabled is true
    await (ttciEnabled ? (0, $fdKY9.webVitalsObserver).ttciDetermined : Promise.resolve());
    // wait up to $timeout ms longer for web-vitals until returning
    const timeoutWindow = new Promise((resolve)=>setTimeout(resolve, timeout));
    await Promise.race([
        timeoutWindow,
        (0, $fdKY9.webVitalsObserver).webVitalsDetermined
    ]);
    return (0, $fdKY9.webVitalsObserver).data;
};

});
parcelRegister("3BGDk", function(module, exports) {

$parcel$export(module.exports, "pageVisibleValue", () => $17b1fdd756b362ba$export$177b923114656380);

var $a4Xpq = parcelRequire("a4Xpq");
var $2n5zh = parcelRequire("2n5zh");
const $17b1fdd756b362ba$export$177b923114656380 = (_config, data, globalConfig)=>{
    const value = globalConfig.pageVisibleValueOrigin === (0, $2n5zh.PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, $a4Xpq.PageVisibleState).VISIBLE;
    return {
        'pageVisible:value': value
    };
};

});


parcelRegister("1A0CZ", function(module, exports) {

$parcel$export(module.exports, "pageVisibleState", () => $e933c91a9d4283d7$export$723b4c298aca63af);
const $e933c91a9d4283d7$export$723b4c298aca63af = (_config, data)=>{
    return {
        'pageVisible:state': data.pageVisibleState
    };
};

});

parcelRegister("aTi94", function(module, exports) {

$parcel$export(module.exports, "productCustomData", () => $fcdee15fecff162e$export$fa2af6e412815a74);
const $fcdee15fecff162e$export$fa2af6e412815a74 = async (_config, data, globalConfig)=>{
    if (!globalConfig.custom && !globalConfig.plugins) return null;
    const result = {};
    if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(([key, value])=>{
        result[`${globalConfig.product}:${key}`] = value;
    });
    if (globalConfig.plugins) {
        const pluginOutputs = await Promise.all(globalConfig.plugins.map((plugin)=>plugin({
                start: data.start,
                stop: data.stop,
                key: data.key
            })));
        pluginOutputs.forEach((pluginOutput)=>{
            if (pluginOutput === null) return;
            Object.entries(pluginOutput).forEach(([key, value])=>{
                result[`${globalConfig.product}:${key}`] = value;
            });
        });
    }
    return result;
};

});

parcelRegister("hwBrS", function(module, exports) {

$parcel$export(module.exports, "ssrFeatureFlags", () => $7ef138ea8443af94$export$fdbea518c19dfa8);

var $2n5zh = parcelRequire("2n5zh");
const $7ef138ea8443af94$var$retrieveFeatureFlags = async (getFeatureFlags)=>{
    try {
        const featureFlags = await getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};
const $7ef138ea8443af94$export$fdbea518c19dfa8 = async (config, _data, globalConfig)=>{
    // no config or missing
    if (!globalConfig.ssr?.getFeatureFlags) return null;
    const includeFeatureFlags = config.ssr?.includeFeatureFlags || globalConfig.ssr?.includeFeatureFlags || (0, $2n5zh.IncludeSSRFeatureFlagsConfig).WHEN_FMP;
    if (includeFeatureFlags === (0, $2n5zh.IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || config.ssr?.doneAsFmp && includeFeatureFlags === (0, $2n5zh.IncludeSSRFeatureFlagsConfig).WHEN_FMP) return await $7ef138ea8443af94$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
    return null;
};

});

parcelRegister("g5ZHz", function(module, exports) {

$parcel$export(module.exports, "ssrSuccess", () => $00c335703180b14a$export$a3dc8251cf55b2e0);
const $00c335703180b14a$export$a3dc8251cf55b2e0 = (config, _data, globalConfig)=>{
    if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("3uwOU", function(module, exports) {

$parcel$export(module.exports, "telemetryBrowser", () => $d97e502ec8fe53e9$export$386b10ac64a50b1);

var $4XKM3 = parcelRequire("4XKM3");
const $d97e502ec8fe53e9$export$386b10ac64a50b1 = ()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($4XKM3))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($4XKM3))).getParser(window.navigator.userAgent);
    return {
        'telemetry:browser:name': browser.getBrowserName(),
        'telemetry:browser:version': browser.getBrowserVersion()
    };
};

});

parcelRegister("l1DMD", function(module, exports) {

$parcel$export(module.exports, "telemetryCpu", () => $4b859e329b6b516d$export$9f84cb359ed29139);
const $4b859e329b6b516d$export$9f84cb359ed29139 = ()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'telemetry:cpus': navigator.hardwareConcurrency
    };
};

});

parcelRegister("4iKEF", function(module, exports) {

$parcel$export(module.exports, "telemetryMemory", () => $e169f2d63e9f37c6$export$496c14d72b257e07);
const $e169f2d63e9f37c6$export$496c14d72b257e07 = ()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'telemetry:memory': navigator.deviceMemory
    };
};

});

parcelRegister("4vxQk", function(module, exports) {

$parcel$export(module.exports, "telemetryNetwork", () => $547d5b6756b35bff$export$88bf7b55f7fc4e8e);
const $547d5b6756b35bff$export$88bf7b55f7fc4e8e = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("eTYgb", function(module, exports) {

$parcel$export(module.exports, "appTimings", () => $4dba244d1acc4f74$export$e952f50a4f2d02da);

var $2n5zh = parcelRequire("2n5zh");

var $bbBBh = parcelRequire("bbBBh");

var $kF32C = parcelRequire("kF32C");
const $4dba244d1acc4f74$export$e952f50a4f2d02da = (config, data, globalConfig)=>{
    const explicitTimings = config.type === (0, $2n5zh.BMEventsType).PAGE_LOAD && data.explicitTimings || null;
    const timings = (0, $bbBBh.customTimings)(config, data);
    const ssr = config.type === (0, $2n5zh.BMEventsType).PAGE_LOAD && data.isInitial ? (0, $kF32C.ssrTimings)(config, data, globalConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("bbBBh", function(module, exports) {

$parcel$export(module.exports, "customTimings", () => $6cea98a29d6ece7f$export$6126f85083a72c6e);

const $6cea98a29d6ece7f$var$retrieveTimings = (config, data, relativeTo = 0, prefix = '')=>{
    const configTimings = config.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        if (timing.startMark && !data.marks[timing.startMark]) return entries;
        if (timing.endMark && !data.marks[timing.endMark]) return entries;
        if (data.start === null || data.stop === null) return null;
        const startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
        const duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
        entries[`${prefix}${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $6cea98a29d6ece7f$export$6126f85083a72c6e = (config, data)=>{
    if (!config.timings && data.submetrics.length === 0) return null;
    const timings = $6cea98a29d6ece7f$var$retrieveTimings(config, data);
    data.submetrics.forEach((submetric)=>{
        if (submetric.start !== null && submetric.stop !== null) {
            const submetricPrefix = `include:${submetric.config.key}`;
            timings[submetricPrefix] = {
                startTime: Math.round(submetric.start - data.start),
                duration: Math.round(submetric.stop - submetric.start)
            };
            Object.assign(timings, $6cea98a29d6ece7f$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $4dde4f2c415dd717$export$b98e411ae80c806f)));
        }
    });
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});
const $4dde4f2c415dd717$export$b98e411ae80c806f = '/';


parcelRegister("kF32C", function(module, exports) {

$parcel$export(module.exports, "ssrTimings", () => $4b327d883bef5a71$export$130f411261a599c5);

const $4b327d883bef5a71$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $4b327d883bef5a71$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $4b327d883bef5a71$var$SSR_PREFIX = 'ssr';
const $4b327d883bef5a71$var$mapKey = (key)=>{
    if (key === 'total') return $4b327d883bef5a71$var$SSR_PREFIX;
    return `${$4b327d883bef5a71$var$SSR_PREFIX}${0, $4dde4f2c415dd717$export$b98e411ae80c806f}${key}`;
};
const $4b327d883bef5a71$export$130f411261a599c5 = (_config, _data, globalConfig)=>{
    if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
    const timings = globalConfig.ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($4b327d883bef5a71$var$filterEntry(entry[1])) acc[$4b327d883bef5a71$var$mapKey(entry[0])] = $4b327d883bef5a71$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});


parcelRegister("bMb3e", function(module, exports) {

$parcel$export(module.exports, "bundleEvalTimings", () => $27f68114f4d490ca$export$1a2bb347935fc536);
const $27f68114f4d490ca$var$bundleEvalTimingsInternal = (_config, data, globalConfig, performance = window.performance)=>{
    const started = {};
    const timings = {};
    const enableBundleEvalTimings = globalConfig?.enableBundleEvalTimings ?? true;
    performance.getEntriesByType('mark').forEach((mark)=>{
        if (!globalConfig.bundleEvalTimings) return;
        const result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && data.start !== null && mark.startTime >= data.start) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.start),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
        const result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};
const $27f68114f4d490ca$export$1a2bb347935fc536 = (...args)=>{
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve($27f68114f4d490ca$var$bundleEvalTimingsInternal(...args));
        });
    });
};

});

parcelRegister("kgkCZ", function(module, exports) {

$parcel$export(module.exports, "resourceTimings", () => $eb3565672ca58926$export$81a7d52441a06b50);
const $eb3565672ca58926$var$cacheableTypes = [
    'script',
    'link'
];
const $eb3565672ca58926$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $eb3565672ca58926$var$CACHE_NETWORK = 'network';
const $eb3565672ca58926$var$CACHE_MEMORY = 'memory';
const $eb3565672ca58926$var$CACHE_DISK = 'disk';
const $eb3565672ca58926$var$calculateTransferType = (type, duration, size)=>{
    if (!$eb3565672ca58926$var$cacheableTypes.includes(type)) return $eb3565672ca58926$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $eb3565672ca58926$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $eb3565672ca58926$var$CACHE_DISK;
    if (size === undefined) return null;
    return $eb3565672ca58926$var$CACHE_NETWORK;
};
const $eb3565672ca58926$var$hasAccessToResourceSize = (url, type, hasTimingHeaders)=>{
    return !$eb3565672ca58926$var$cacheableTypes.includes(type) || url.includes('localhost') || url.includes(window.location.hostname) || hasTimingHeaders(url);
};
const $eb3565672ca58926$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $eb3565672ca58926$var$withoutHeaders = ()=>false;
const $eb3565672ca58926$var$evaluateAccessToResourceTimings = (entry)=>{
    if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
    return true;
};
const $eb3565672ca58926$var$getEvaluatedTimingHeader = (entry, enabled = false, hasTimingHeaders = $eb3565672ca58926$var$withoutHeaders)=>{
    if (!enabled) return null;
    const manualResolution = entry.name.includes('localhost') || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
    const autoResolution = $eb3565672ca58926$var$evaluateAccessToResourceTimings(entry);
    return {
        m_h: manualResolution,
        a_h: autoResolution
    };
};
const $eb3565672ca58926$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $eb3565672ca58926$var$getNetworkData = (item, eventStart, hasTimingHeaders = $eb3565672ca58926$var$withoutHeaders)=>{
    const { name: name, duration: duration, transferSize: size, initiatorType: type, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$eb3565672ca58926$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
    if ($eb3565672ca58926$var$cacheableTypes.includes(type)) {
        const transferType = $eb3565672ca58926$var$calculateTransferType(type, duration, size);
        if (!transferType) return {
            ttfb: ttfb,
            ...$eb3565672ca58926$var$getSizeObject(size)
        };
        if (transferType !== $eb3565672ca58926$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$eb3565672ca58926$var$getSizeObject(size)
        };
    }
    return {
        ttfb: ttfb,
        ...$eb3565672ca58926$var$getSizeObject(size)
    };
};
const $eb3565672ca58926$export$81a7d52441a06b50 = (_config, data, globalConfig, performance = window.performance)=>{
    if (data.start === null) return null;
    const resources = performance.getEntriesByType('resource').filter((entry)=>entry.startTime >= data.start);
    if (!resources.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = globalConfig.resourceTimings;
    const reportedInitiatorTypes = $eb3565672ca58926$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: type } = item;
        if (!name) return;
        if (type === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $eb3565672ca58926$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
        if (resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.start),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.start), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
            type: type,
            ...$eb3565672ca58926$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders),
            ...$eb3565672ca58926$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});


parcelRegister("bq6vn", function(module, exports) {

$parcel$export(module.exports, "makeShareableGlobalConfig", () => $80383f91ab961373$export$5b4fb14409a2a825);

var $2n5zh = parcelRequire("2n5zh");
const $80383f91ab961373$var$makeFeatureFlags = (allFeatureFlags, eventTypeFeatureFlags)=>{
    const featureFlagsForType = [];
    if (allFeatureFlags) featureFlagsForType.push(...allFeatureFlags);
    if (eventTypeFeatureFlags) featureFlagsForType.push(...eventTypeFeatureFlags);
    return featureFlagsForType;
};
const $80383f91ab961373$var$makeGlobalConfigPerType = (global, ffClient, allEventsConfig, eventConfig)=>{
    const allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
    const eventConfigCustom = eventConfig && eventConfig.custom;
    const custom = (allEventsConfigCustom || eventConfigCustom) && {
        ...allEventsConfigCustom,
        ...eventConfigCustom
    } || undefined;
    const allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
    const eventConfigPlugins = eventConfig && eventConfig.plugins;
    const plugins = (allEventsConfigPlugins || eventConfigPlugins) && [
        ...allEventsConfigPlugins || [],
        ...eventConfigPlugins || []
    ] || undefined;
    const pageVisibleValueOrigin = eventConfig?.pageVisibleValueOrigin ?? allEventsConfig?.pageVisibleValueOrigin ?? (0, $2n5zh.PageVisibleValueOrigin).documentHidden;
    return Object.freeze({
        ...global,
        featureFlags: Object.freeze($80383f91ab961373$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce((acc, value)=>{
            acc[value] = ffClient.getValue(value);
            return acc;
        }, {})),
        custom: custom,
        plugins: plugins,
        histogram: eventConfig?.histogram,
        pageVisibleValueOrigin: pageVisibleValueOrigin,
        enableBundleEvalTimings: eventConfig?.enableBundleEvalTimings
    });
};
const $80383f91ab961373$export$5b4fb14409a2a825 = async (globalConfig)=>{
    const ffClient = await globalConfig.plugins.featureFlags.client;
    const global = {
        app: globalConfig.info.app,
        product: globalConfig.info.product,
        region: globalConfig.info.region,
        resourceTimings: globalConfig.plugins.resourceTimings,
        bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
        ffClient: ffClient,
        hostname: globalConfig.info.hostname || window.location.hostname,
        ssr: globalConfig.ssr,
        enableReactUFOTracker: globalConfig.enableReactUFOTracker,
        webVitals: {
            enabled: globalConfig.events[(0, $2n5zh.BMEventsType).WEB_VITALS]?.enabled,
            timeout: globalConfig.events[(0, $2n5zh.BMEventsType).WEB_VITALS]?.timeout,
            ttciEnabled: globalConfig.events[(0, $2n5zh.BMEventsType).WEB_VITALS]?.ttciEnabled
        }
    };
    return {
        [(0, $2n5zh.BMEventsType).PAGE_LOAD]: $80383f91ab961373$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $2n5zh.BMEventsType).PAGE_LOAD]),
        [(0, $2n5zh.BMEventsType).PAGE_SEGMENT_LOAD]: $80383f91ab961373$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $2n5zh.BMEventsType).PAGE_SEGMENT_LOAD]),
        [(0, $2n5zh.BMEventsType).INLINE_RESULT]: $80383f91ab961373$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $2n5zh.BMEventsType).INLINE_RESULT]),
        [(0, $2n5zh.BMEventsType).CUSTOM]: $80383f91ab961373$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $2n5zh.BMEventsType).CUSTOM]),
        [(0, $2n5zh.BMEventsType).WEB_VITALS]: $80383f91ab961373$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $2n5zh.BMEventsType).WEB_VITALS])
    };
};

});



parcelRegister("eEK28", function(module, exports) {

$parcel$export(module.exports, "ufologger", () => $0008c94eceb5d65d$export$4ab84f6f04f6566d);
$parcel$export(module.exports, "ufolog", () => $0008c94eceb5d65d$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $0008c94eceb5d65d$export$d53d07b6034c4560);
class $0008c94eceb5d65d$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($0008c94eceb5d65d$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($0008c94eceb5d65d$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $0008c94eceb5d65d$export$4ab84f6f04f6566d = new $0008c94eceb5d65d$var$UFOLogger();
const $0008c94eceb5d65d$export$b4958caff08a0960 = (...args)=>{
    $0008c94eceb5d65d$export$4ab84f6f04f6566d.log(...args);
};
const $0008c94eceb5d65d$export$d53d07b6034c4560 = (...args)=>{
    $0008c94eceb5d65d$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("fElyJ", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $4bf0ea145c9d5c34$export$15e172712955e18f);
const $4bf0ea145c9d5c34$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});

parcelRegister("gPCjK", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $89ac10445476bffd$export$6123a44dc2384540);
$parcel$export(module.exports, "setGlobalEventStream", () => $89ac10445476bffd$export$c1522520b417b066);
$parcel$export(module.exports, "subscribeEvent", () => $89ac10445476bffd$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $89ac10445476bffd$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $89ac10445476bffd$export$7c957416596ca127);

var $eEK28 = parcelRequire("eEK28");

var $hZIhe = parcelRequire("hZIhe");
const $89ac10445476bffd$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $89ac10445476bffd$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $89ac10445476bffd$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $89ac10445476bffd$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $eEK28.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $89ac10445476bffd$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $hZIhe.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $89ac10445476bffd$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $hZIhe.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $89ac10445476bffd$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $hZIhe.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("hZIhe", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $70ab9cc745b29430$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $70ab9cc745b29430$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $70ab9cc745b29430$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $70ab9cc745b29430$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $70ab9cc745b29430$export$837e0f79a8056912);
var $70ab9cc745b29430$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $70ab9cc745b29430$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $70ab9cc745b29430$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $70ab9cc745b29430$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $70ab9cc745b29430$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $70ab9cc745b29430$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $70ab9cc745b29430$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $70ab9cc745b29430$export$9f2bf58999404c75 = 'fmp';
const $70ab9cc745b29430$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("by9qv", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $4d4d4b67b7f3c6d5$export$13e680397ec8f3eb);

var $fElyJ = parcelRequire("fElyJ");
class $4d4d4b67b7f3c6d5$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $fElyJ.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $4d4d4b67b7f3c6d5$export$13e680397ec8f3eb = new $4d4d4b67b7f3c6d5$var$VisibilityChangeObserver();

});

parcelRegister("bqNYX", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $a831330916b6d572$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $a831330916b6d572$export$cc26007c03242fff);
var $a831330916b6d572$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $a831330916b6d572$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("b5KMq", function(module, exports) {

$parcel$export(module.exports, "payloadPublisher", () => $7b68fbee34360fa8$export$edb879ae55bb9be3);

var $bqNYX = parcelRequire("bqNYX");
var $by9qv = parcelRequire("by9qv");

var $gPCjK = parcelRequire("gPCjK");

var $eEK28 = parcelRequire("eEK28");

var $hZIhe = parcelRequire("hZIhe");


var $hYjMZ = parcelRequire("hYjMZ");

var $kM9Ej = parcelRequire("kM9Ej");

var $7Bp3i = parcelRequire("7Bp3i");

var $jji4B = parcelRequire("jji4B");

var $6bE9r = parcelRequire("6bE9r");

var $6EiMV = parcelRequire("6EiMV");

var $5PvFl = parcelRequire("5PvFl");

var $7sb8G = parcelRequire("7sb8G");

var $9c4Xf = parcelRequire("9c4Xf");

var $3Yuby = parcelRequire("3Yuby");

var $fligS = parcelRequire("fligS");

var $j2LUD = parcelRequire("j2LUD");

var $cKlMl = parcelRequire("cKlMl");

var $27a2m = parcelRequire("27a2m");

var $4FqrW = parcelRequire("4FqrW");

var $cB5uY = parcelRequire("cB5uY");

var $cMCnl = parcelRequire("cMCnl");
const $7b68fbee34360fa8$var$UNKNOWN_VALUE = 'unknown';
const $7b68fbee34360fa8$var$DEFAULT_PAYLOAD_DATA = {
    schemaVersion: $7b68fbee34360fa8$var$UNKNOWN_VALUE,
    id: $7b68fbee34360fa8$var$UNKNOWN_VALUE,
    uuid: $7b68fbee34360fa8$var$UNKNOWN_VALUE,
    state: {
        id: $7b68fbee34360fa8$var$UNKNOWN_VALUE
    },
    result: {
        startTime: 0,
        duration: 0,
        success: false
    },
    type: (0, $bqNYX.ExperienceTypes).Experience,
    category: $7b68fbee34360fa8$var$UNKNOWN_VALUE,
    performanceType: (0, $bqNYX.ExperiencePerformanceTypes).Custom,
    metadata: {},
    explicitTimings: {},
    metrics: {
        startTime: 0,
        endTime: 0,
        marks: []
    },
    platform: null,
    children: [],
    pageVisibleState: (0, $hZIhe.PageVisibleState).MIXED,
    isSSROutputAsFMP: false,
    timings: [],
    featureFlags: []
};
class $7b68fbee34360fa8$var$Publisher {
    publish(data) {
        const payloadStart = (0, $cMCnl.getPerformanceObject)()?.now() || 0;
        const experienceKey = this.getExperienceKey(data);
        if (!this.allowlist(experienceKey, data)) {
            (0, $eEK28.ufowarn)(`experience ${experienceKey} does not meet requirements of allowlist`);
            return;
        }
        // it is used to setup default properties on the data to prevent errors
        const supportedData = {
            ...$7b68fbee34360fa8$var$DEFAULT_PAYLOAD_DATA,
            ...data
        };
        const payload = {
            actionSubject: 'experience',
            action: 'measured',
            source: 'measured',
            tags: [
                'observability'
            ],
            attributes: {
                properties: {
                    'event:source': {
                        name: 'ufo/web',
                        version: supportedData.schemaVersion
                    },
                    'event:schema': (0, $79f9fa0a327fcd1e$export$93809551debf385f) || $7b68fbee34360fa8$var$UNKNOWN_VALUE,
                    'event:product': this.product,
                    'event:region': this.region,
                    'event:hostname': this.hostname,
                    'event:route': this.route.getRoute(),
                    ...(0, $7sb8G.eventBrowserPlugin)(),
                    ...(0, $9c4Xf.eventCpusPlugin)(),
                    ...(0, $fligS.eventMemoryPlugin)(),
                    ...(0, $j2LUD.eventNetworkPlugin)(),
                    ...(0, $6EiMV.appFramework)(this.app),
                    ...(0, $5PvFl.appVersion)(this.app),
                    'experience:name': supportedData.id,
                    // platform.fe.page-load|interaction|custom|page-segment.editor
                    'experience:key': experienceKey,
                    'experience:status': supportedData.state.id,
                    'experience:duration': supportedData.result.duration,
                    ...supportedData.result.startTime !== null ? {
                        'experience:startTime': supportedData.result.startTime
                    } : null,
                    ...supportedData.uuid ? {
                        'experience:spanId': supportedData.uuid
                    } : null,
                    ...this.tenantType !== (0, $hYjMZ.TenantType).RealUser ? {
                        'event:tenantType': this.tenantType
                    } : null,
                    ...this.mapMetadataToPayload(supportedData.metadata),
                    ...this.extractPageLoadData(supportedData),
                    ...(0, $jji4B.pageVisibleState)(supportedData),
                    ...(0, $cB5uY.isInitialPageLoad)(supportedData) && (0, $27a2m.ssrSuccess)(this.ssr),
                    ...(0, $cB5uY.isInitialPageLoad)(supportedData) && (0, $cKlMl.ssrFeatureFlags)(this.ssr),
                    ...this.featureFlagClient && (0, $3Yuby.featureFlags)(this.featureFlagClient, this.featureFlags, supportedData)
                },
                performance: this.getPerformanceMetrics(supportedData),
                task: supportedData.id
            }
        };
        const payloadEnd = (0, $cMCnl.getPerformanceObject)()?.now() || 0;
        payload.attributes.performance.payloadTime = payloadEnd - payloadStart;
        if (this.gasv3) this.gasv3.sendOperationalEvent(payload);
        else this.buffer.push(payload);
        (0, $eEK28.ufolog)('PAYLOAD:', JSON.stringify(payload, null, 2));
    }
    setGlobalEventStream() {
        if (!((0, $gPCjK.getGlobalEventStream)() instanceof (0, $kM9Ej.UFOGlobalEventStream))) {
            const eventStream = new (0, $kM9Ej.UFOGlobalEventStream)();
            eventStream.push({
                type: (0, $hZIhe.UFOGlobalEventStreamEventType).SUBSCRIBE,
                payload: {
                    experienceId: '__SUBSCRIBE_ALL__',
                    callback: this.publish.bind(this)
                }
            });
            (0, $gPCjK.setGlobalEventStream)(eventStream);
        }
    }
    setRoute(newRoute) {
        this.route.setRoute(newRoute);
    }
    setup(config) {
        (0, $by9qv.visibilityChangeObserver).start();
        (0, $6bE9r.resourceTimingBuffer).start();
        if (!this.product) this.product = config.product || '';
        if (config.allowlist) this.allowlist = config.allowlist;
        if (config.tenantType) this.tenantType = config.tenantType;
        if (config.hostname) this.hostname = config.hostname;
        if (config.region) this.region = config.region;
        if (config.app) this.app = config.app;
        if (config.featureFlagClient) this.featureFlagClient = config.featureFlagClient;
        if (config.featureFlags) this.featureFlags = config.featureFlags;
        if (config.ssr) this.ssr = config.ssr;
        if (config.bundleEvalTimings) this.bundleEvalTimings = config.bundleEvalTimings;
        if (config.resourceTimings) this.resourceTimings = config.resourceTimings;
        if (config.performanceConfig) this.performanceConfig = config.performanceConfig;
        if (config.plugins) this.plugins = config.plugins;
        this.setGlobalEventStream();
        if (!this.gasv3) {
            this.gasv3 = config.gasv3;
            this.buffer.forEach(this.gasv3.sendOperationalEvent);
        }
    }
    mapMetadataToPayload(metadata) {
        const payload = {};
        Object.entries(metadata).forEach(([key, value])=>{
            if (value !== undefined) payload[`custom:${key}`] = value;
        });
        return payload;
    }
    extractPageLoadData(data) {
        if ('initial' in data) return {
            'experience:pageLoadType': data.initial ? 'initial' : 'transition'
        };
        return {};
    }
    getPrefix(data) {
        if (data.platform !== null) return 'platform';
        return this.product;
    }
    getExperienceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.type
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.performanceType
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceType(data) {
        return data.performanceType;
    }
    getPerformanceMetrics(data) {
        return {
            'event:key': this.getExperiencePerformanceKey(data),
            'event:type': this.getExperiencePerformanceType(data),
            ...(0, $7Bp3i.getPerformancePayload)(data, this.ssr, this.bundleEvalTimings, this.resourceTimings, this.performanceConfig),
            ...this.getPluginsMetrics(data)
        };
    }
    constructor(){
        this.gasv3 = null;
        this.product = '';
        this.region = $7b68fbee34360fa8$var$UNKNOWN_VALUE;
        this.hostname = (0, $cMCnl.getWindowObject)()?.location?.hostname || '';
        this.tenantType = (0, $hYjMZ.TenantType).RealUser;
        this.app = {
            version: {
                web: $7b68fbee34360fa8$var$UNKNOWN_VALUE
            }
        };
        this.performanceConfig = {};
        this.buffer = [];
        this.featureFlagClient = null;
        this.featureFlags = [];
        this.ssr = null;
        this.resourceTimings = null;
        this.bundleEvalTimings = null;
        this.route = (0, $4FqrW.Route);
        this.plugins = null;
        this.allowlist = ()=>true;
        this.getPluginsMetrics = (data)=>{
            const result = {};
            if (this.plugins) this.plugins.forEach((plugin)=>{
                const pluginOutput = plugin({
                    ...data
                });
                if (pluginOutput === null || typeof pluginOutput !== 'object') return;
                Object.entries(pluginOutput).forEach(([key, value])=>{
                    result[`${this.product}:${key}`] = value;
                });
            });
            return result;
        };
    }
}
const $7b68fbee34360fa8$export$edb879ae55bb9be3 = new $7b68fbee34360fa8$var$Publisher();

});
// temp solution until a proper versioning
const $79f9fa0a327fcd1e$export$93809551debf385f = '0.1.7';

parcelRegister("hYjMZ", function(module, exports) {

$parcel$export(module.exports, "TenantType", () => $9679140bc34ed0b8$export$92a757ac1398962f);

var $9679140bc34ed0b8$export$92a757ac1398962f = /*#__PURE__*/ function(TenantType) {
    TenantType["RealUser"] = "real-user";
    TenantType["Synthetic"] = "synthetic";
    return TenantType;
}({});

});

parcelRegister("kM9Ej", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStream", () => $20cdc595d0f6a57c$export$faf4c91b80fc830e);

var $eEK28 = parcelRequire("eEK28");

var $hZIhe = parcelRequire("hZIhe");
class $20cdc595d0f6a57c$export$faf4c91b80fc830e {
    push(event) {
        (0, $eEK28.ufolog)('EVENT STREAM push', event.type, event.payload);
        if (event.type === (0, $hZIhe.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD) this.publish(event.payload);
        if (event.type === (0, $hZIhe.UFOGlobalEventStreamEventType).SUBSCRIBE) this.subscribe(event.payload.experienceId, event.payload.callback);
        if (event.type === (0, $hZIhe.UFOGlobalEventStreamEventType).UNSUBSCRIBE) this.unsubscribe(event.payload.experienceId, event.payload.callback);
    }
    publish(eventPayload) {
        if (this.subscribers[0, $hZIhe.SUBSCRIBE_ALL]) this.subscribers[0, $hZIhe.SUBSCRIBE_ALL].forEach((fn)=>{
            fn(eventPayload);
        });
        this.subscribers[eventPayload.id]?.forEach((fn)=>{
            fn(eventPayload);
        });
    }
    subscribe(experienceId, fn) {
        (0, $eEK28.ufolog)('EVENT STREAM subscribe', experienceId);
        if (!this.subscribers[experienceId]) this.subscribers[experienceId] = [];
        this.subscribers[experienceId].push(fn);
    }
    unsubscribe(experienceId, fn) {
        const index = this.subscribers[experienceId].findIndex((entry)=>entry === fn);
        if (index !== -1) this.subscribers[experienceId].splice(index, 1);
    }
    constructor(){
        this.__buffer_only__ = false;
        this.subscribers = {};
    }
}

});

parcelRegister("7Bp3i", function(module, exports) {

$parcel$export(module.exports, "getPerformancePayload", () => $0c7903aea92ce244$export$738d24377baf6a5e);

var $bqNYX = parcelRequire("bqNYX");

var $hZIhe = parcelRequire("hZIhe");

var $cB5uY = parcelRequire("cB5uY");

var $iGKkF = parcelRequire("iGKkF");

var $lAYqh = parcelRequire("lAYqh");

var $fq904 = parcelRequire("fq904");

var $5nhe7 = parcelRequire("5nhe7");
const $0c7903aea92ce244$var$LoadMetricKeys = {
    tti: 'metric:tti',
    fmp: 'metric:fmp',
    ttiHistograms: 'metric:tti:histogramBuckets',
    fmpHistograms: 'metric:fmp:histogramBuckets'
};
const $0c7903aea92ce244$var$InlineResultMetricKeys = {
    result: 'metric:result',
    response: 'metric:response',
    resultHistograms: 'metric:result:histogramBuckets',
    responseHistograms: 'metric:response:histogramBuckets'
};
const $0c7903aea92ce244$var$CustomMetricKeys = {
    duration: 'metric:duration',
    durationHistograms: 'metric:duration:histogramBuckets'
};
const $0c7903aea92ce244$var$getHistogram = (data, performanceConfig, isInitial)=>{
    let histogram = {};
    if (data.performanceConfig?.histogram) histogram = data.performanceConfig.histogram;
    else if (performanceConfig?.histogram) histogram = performanceConfig.histogram;
    if (histogram) {
        const histograms = histogram[data.performanceType];
        switch(data.performanceType){
            case (0, $bqNYX.ExperiencePerformanceTypes).PageLoad:
            case (0, $bqNYX.ExperiencePerformanceTypes).PageSegmentLoad:
                const histogramType = isInitial !== undefined && isInitial === true ? 'initial' : 'transition';
                return histograms ? {
                    [$0c7903aea92ce244$var$LoadMetricKeys.ttiHistograms]: histograms[histogramType].tti,
                    [$0c7903aea92ce244$var$LoadMetricKeys.fmpHistograms]: histograms[histogramType].fmp
                } : {};
            case (0, $bqNYX.ExperiencePerformanceTypes).InlineResult:
                return histograms ? {
                    [$0c7903aea92ce244$var$InlineResultMetricKeys.resultHistograms]: histograms.result,
                    [$0c7903aea92ce244$var$InlineResultMetricKeys.responseHistograms]: histograms.response
                } : {};
            case (0, $bqNYX.ExperiencePerformanceTypes).Custom:
                return histograms ? {
                    [$0c7903aea92ce244$var$CustomMetricKeys.durationHistograms]: histograms.duration
                } : {};
        }
    }
};
const $0c7903aea92ce244$export$bd4e6d81a822ece6 = (data, ssr, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === (0, $hZIhe.FMP_MARK))?.time || (0, $cB5uY.isInitialPageLoad)(data) && ssr?.getDoneMark();
    const tti = data.metrics.endTime - data.metrics.startTime;
    const fmp = typeof fmpMark === 'number' ? fmpMark - data.metrics.startTime : tti;
    return {
        [$0c7903aea92ce244$var$LoadMetricKeys.tti]: Math.round(tti),
        [$0c7903aea92ce244$var$LoadMetricKeys.fmp]: Math.round(fmp),
        ...$0c7903aea92ce244$var$getHistogram(data, performanceConfig)
    };
};
const $0c7903aea92ce244$export$47f0208fd62dffce = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const responseMark = data.metrics.marks.find((mark)=>mark.name === (0, $hZIhe.INLINE_RESPONSE_MARK));
    const result = data.metrics.endTime - data.metrics.startTime;
    const response = responseMark ? responseMark.time - data.metrics.startTime : result;
    return {
        [$0c7903aea92ce244$var$InlineResultMetricKeys.result]: Math.round(result),
        [$0c7903aea92ce244$var$InlineResultMetricKeys.response]: Math.round(response),
        ...$0c7903aea92ce244$var$getHistogram(data, performanceConfig)
    };
};
const $0c7903aea92ce244$export$c25c1b3ff2ce92cf = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const duration = data.metrics.endTime - data.metrics.startTime;
    return {
        [$0c7903aea92ce244$var$CustomMetricKeys.duration]: Math.round(duration),
        ...$0c7903aea92ce244$var$getHistogram(data, performanceConfig)
    };
};
const $0c7903aea92ce244$var$getPerformanceMetrics = (data, ssr, performanceConfig)=>{
    switch(data.performanceType){
        case (0, $bqNYX.ExperiencePerformanceTypes).PageLoad:
        case (0, $bqNYX.ExperiencePerformanceTypes).PageSegmentLoad:
            return $0c7903aea92ce244$export$bd4e6d81a822ece6(data, ssr, performanceConfig);
        case (0, $bqNYX.ExperiencePerformanceTypes).InlineResult:
            return $0c7903aea92ce244$export$47f0208fd62dffce(data, performanceConfig);
        case (0, $bqNYX.ExperiencePerformanceTypes).Custom:
            return $0c7903aea92ce244$export$c25c1b3ff2ce92cf(data, performanceConfig);
    }
};
const $0c7903aea92ce244$export$738d24377baf6a5e = (data, ssr, bundleEvalConfig, resourceConfig, performanceConfig)=>{
    return {
        ...$0c7903aea92ce244$var$getPerformanceMetrics(data, ssr, performanceConfig),
        ...(0, $5nhe7.resourceTimings)(data, resourceConfig),
        ...(0, $fq904.bundleEvalTimings)(data, bundleEvalConfig),
        ...(0, $lAYqh.appTimings)(data, ssr),
        ...(0, $cB5uY.isInitialPageLoad)(data) ? (0, $iGKkF.navigationMetrics)() : null
    };
};

});
parcelRegister("cB5uY", function(module, exports) {

$parcel$export(module.exports, "isInitialPageLoad", () => $36a7525a385e882f$export$7167d96e9881d500);

var $bqNYX = parcelRequire("bqNYX");
const $36a7525a385e882f$export$7167d96e9881d500 = (data)=>{
    return data.performanceType === (0, $bqNYX.ExperiencePerformanceTypes).PageLoad && data.initial === true;
};

});

parcelRegister("iGKkF", function(module, exports) {

$parcel$export(module.exports, "navigationMetrics", () => $fcbd40c8214e4fa4$export$b88d990436be0f8a);
const $fcbd40c8214e4fa4$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("lAYqh", function(module, exports) {

$parcel$export(module.exports, "appTimings", () => $6444d6e30df26a73$export$e952f50a4f2d02da);

var $bqNYX = parcelRequire("bqNYX");

var $cB5uY = parcelRequire("cB5uY");

var $4sb8P = parcelRequire("4sb8P");

var $7mPvE = parcelRequire("7mPvE");
const $6444d6e30df26a73$export$e952f50a4f2d02da = (data, ssrConfig)=>{
    const explicitTimings = data.performanceType === (0, $bqNYX.ExperiencePerformanceTypes).PageLoad && data.explicitTimings || null;
    const timings = (0, $4sb8P.customTimings)(data);
    const ssr = (0, $cB5uY.isInitialPageLoad)(data) ? (0, $7mPvE.ssrTimings)(ssrConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp || Object.keys(timingsApp).length === 0) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("4sb8P", function(module, exports) {

$parcel$export(module.exports, "customTimings", () => $7bdd2a901ff81ffe$export$6126f85083a72c6e);
const $7bdd2a901ff81ffe$var$retrieveTimings = (data)=>{
    const configTimings = data.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        const startMark = data.metrics.marks.find((mark)=>mark.name === timing.startMark);
        if (timing.startMark && !startMark) return entries;
        const endMark = data.metrics.marks.find((mark)=>mark.name === timing.endMark);
        if (timing.endMark && !endMark) return entries;
        if (data.metrics.startTime === null || data.metrics.endTime === null) return null;
        const startTime = Math.round((startMark ? startMark.time : data.metrics.startTime) - data.metrics.startTime);
        const duration = Math.round((endMark ? endMark.time : data.metrics.endTime) - data.metrics.startTime - startTime);
        entries[`${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $7bdd2a901ff81ffe$export$6126f85083a72c6e = (data)=>{
    if (!data.timings) return null;
    const timings = $7bdd2a901ff81ffe$var$retrieveTimings(data);
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});

parcelRegister("7mPvE", function(module, exports) {

$parcel$export(module.exports, "ssrTimings", () => $72519d5ab3f1fe3e$export$130f411261a599c5);

const $72519d5ab3f1fe3e$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $72519d5ab3f1fe3e$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $72519d5ab3f1fe3e$var$SSR_PREFIX = 'ssr';
const $72519d5ab3f1fe3e$var$mapKey = (key)=>{
    if (key === 'total') return $72519d5ab3f1fe3e$var$SSR_PREFIX;
    return `${$72519d5ab3f1fe3e$var$SSR_PREFIX}${0, $0710c6cc46b1ce22$export$b98e411ae80c806f}${key}`;
};
const $72519d5ab3f1fe3e$export$130f411261a599c5 = (ssr)=>{
    if (!ssr?.getTimings) return null;
    const timings = ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($72519d5ab3f1fe3e$var$filterEntry(entry[1])) acc[$72519d5ab3f1fe3e$var$mapKey(entry[0])] = $72519d5ab3f1fe3e$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});
const $0710c6cc46b1ce22$export$b98e411ae80c806f = '/';



parcelRegister("fq904", function(module, exports) {

$parcel$export(module.exports, "bundleEvalTimings", () => $1dcc6eef54500b9c$export$1a2bb347935fc536);

var $cMCnl = parcelRequire("cMCnl");
const $1dcc6eef54500b9c$export$1a2bb347935fc536 = (data, bundleEvalTimings, performance = (0, $cMCnl.getPerformanceObject)() || undefined)=>{
    if (!bundleEvalTimings) return null;
    const started = {};
    const timings = {};
    performance?.getEntriesByType('mark').forEach((mark)=>{
        const result = bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result || data.result.startTime === null) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= data.result.startTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.result.startTime),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (bundleEvalTimings?.additionalTimings && data.result.startTime !== null) {
        const result = bundleEvalTimings.additionalTimings(data.result.startTime);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};

});
parcelRegister("cMCnl", function(module, exports) {

$parcel$export(module.exports, "getWindowObject", () => $6dee40e9bbcc4c5b$export$9aa44f85591248d9);
$parcel$export(module.exports, "getPerformanceObject", () => $6dee40e9bbcc4c5b$export$8cd0c777b0eb66a0);
$parcel$export(module.exports, "getPerformanceObserverObject", () => $6dee40e9bbcc4c5b$export$74560fd4e61fd440);
const $6dee40e9bbcc4c5b$export$9aa44f85591248d9 = ()=>{
    return typeof window !== 'undefined' && !!window ? window : undefined;
};
const $6dee40e9bbcc4c5b$export$8cd0c777b0eb66a0 = ()=>{
    const { performance: performance } = $6dee40e9bbcc4c5b$export$9aa44f85591248d9() || {};
    return performance;
};
const $6dee40e9bbcc4c5b$export$74560fd4e61fd440 = ()=>{
    const { PerformanceObserver: PerformanceObserver } = $6dee40e9bbcc4c5b$export$9aa44f85591248d9() || {};
    return PerformanceObserver;
};

});


parcelRegister("5nhe7", function(module, exports) {

$parcel$export(module.exports, "resourceTimings", () => $8fe09419d126f95f$export$81a7d52441a06b50);

var $cMCnl = parcelRequire("cMCnl");

var $6bE9r = parcelRequire("6bE9r");
const $8fe09419d126f95f$var$cacheableTypes = [
    'script',
    'link'
];
const $8fe09419d126f95f$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $8fe09419d126f95f$var$CACHE_NETWORK = 'network';
const $8fe09419d126f95f$var$CACHE_MEMORY = 'memory';
const $8fe09419d126f95f$var$CACHE_DISK = 'disk';
const $8fe09419d126f95f$var$calculateTransferType = (type, duration, size)=>{
    if (!$8fe09419d126f95f$var$cacheableTypes.includes(type)) return $8fe09419d126f95f$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $8fe09419d126f95f$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $8fe09419d126f95f$var$CACHE_DISK;
    if (size === undefined) return null;
    return $8fe09419d126f95f$var$CACHE_NETWORK;
};
const $8fe09419d126f95f$var$hasAccessToResourceSize = (url, type, entry, hasTimingHeaders)=>{
    return !$8fe09419d126f95f$var$cacheableTypes.includes(type) || url.includes('localhost') || !!(0, $cMCnl.getWindowObject)() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
};
const $8fe09419d126f95f$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $8fe09419d126f95f$var$evaluateAccessToResourceTimings = (_url, entry)=>{
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
};
const $8fe09419d126f95f$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $8fe09419d126f95f$var$getNetworkData = (item, eventStart, hasTimingHeaders = $8fe09419d126f95f$var$evaluateAccessToResourceTimings)=>{
    const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$8fe09419d126f95f$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($8fe09419d126f95f$var$cacheableTypes.includes(initiatorType)) {
        const transferType = $8fe09419d126f95f$var$calculateTransferType(initiatorType, duration, transferSize);
        if (!transferType) return {
            ttfb: ttfb,
            ...$8fe09419d126f95f$var$getSizeObject(transferSize)
        };
        if (transferType !== $8fe09419d126f95f$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$8fe09419d126f95f$var$getSizeObject(transferSize)
        };
    }
    return {
        ttfb: ttfb,
        ...$8fe09419d126f95f$var$getSizeObject(transferSize)
    };
};
const $8fe09419d126f95f$export$81a7d52441a06b50 = (data, resourceTimings, performance = (0, $cMCnl.getPerformanceObject)() || undefined)=>{
    if (data.result.startTime === null || !resourceTimings?.sanitiseEndpoints) return null;
    const resources = (0, $6bE9r.getResourceTimings)(data.result.startTime, performance);
    if (!resources?.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = resourceTimings;
    const reportedInitiatorTypes = $8fe09419d126f95f$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
        if (!name || data.result.startTime === null) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $8fe09419d126f95f$var$resourceTypes.includes(initiatorType) ? resourceTimings.sanitiseEndpoints(name) : resourceTimings.mapResources(name);
        if (!url || resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.result.startTime),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.result.startTime), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.result.startTime), 0),
            type: initiatorType,
            ...$8fe09419d126f95f$var$getNetworkData(item, data.result.startTime, resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});
parcelRegister("6bE9r", function(module, exports) {

$parcel$export(module.exports, "resourceTimingBuffer", () => $87048bf9240a72a2$export$bea963256235a63e);
$parcel$export(module.exports, "getResourceTimings", () => $87048bf9240a72a2$export$9eebb59359c2e9e5);
// @flow strict-local

var $eEK28 = parcelRequire("eEK28");

var $cMCnl = parcelRequire("cMCnl");
const $87048bf9240a72a2$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: (entry)=>({
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration),
            fetchStart: Math.round(entry.fetchStart || 0),
            workerStart: Math.round(entry.workerStart || 0),
            responseStart: Math.round(entry.responseStart || 0)
        }),
    start: (performance = (0, $cMCnl.getPerformanceObject)(), PerformanceObserver1 = (0, $cMCnl.getPerformanceObserverObject)())=>{
        if (!PerformanceObserver1 || !performance || typeof PerformanceObserver1 === 'undefined') return;
        if ($87048bf9240a72a2$export$bea963256235a63e.observer) {
            (0, $eEK28.ufologger).warn('Observer is already running');
            return;
        }
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $87048bf9240a72a2$export$bea963256235a63e.timings = resources.map((resource)=>$87048bf9240a72a2$export$bea963256235a63e.transformResource(resource));
        $87048bf9240a72a2$export$bea963256235a63e.observer = new PerformanceObserver1($87048bf9240a72a2$export$bea963256235a63e.addTimings);
        $87048bf9240a72a2$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: ()=>{
        if ($87048bf9240a72a2$export$bea963256235a63e.observer) {
            $87048bf9240a72a2$export$bea963256235a63e.observer.disconnect();
            $87048bf9240a72a2$export$bea963256235a63e.observer = null;
        }
        $87048bf9240a72a2$export$bea963256235a63e.timings = [];
    },
    addTimings: (list)=>{
        const entries = list.getEntries().map((entry)=>$87048bf9240a72a2$export$bea963256235a63e.transformResource(entry));
        const overflow = $87048bf9240a72a2$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $87048bf9240a72a2$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $87048bf9240a72a2$export$bea963256235a63e.maxSize;
            $87048bf9240a72a2$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $87048bf9240a72a2$export$bea963256235a63e.timings.push(...entries);
    }
};
const $87048bf9240a72a2$export$9eebb59359c2e9e5 = (startTime, performance = (0, $cMCnl.getPerformanceObject)())=>{
    if (!PerformanceObserver || !$87048bf9240a72a2$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>timing.startTime >= startTime);
        return null;
    }
    return $87048bf9240a72a2$export$bea963256235a63e.timings.filter((timing)=>timing.startTime >= startTime);
};

});



parcelRegister("jji4B", function(module, exports) {

$parcel$export(module.exports, "pageVisibleState", () => $796c7c9ccb55cb6f$export$723b4c298aca63af);

var $hZIhe = parcelRequire("hZIhe");
const $796c7c9ccb55cb6f$export$723b4c298aca63af = (data)=>{
    return {
        'experience:pageVisible': data.pageVisibleState ?? (document.hidden ? (0, $hZIhe.PageVisibleState).HIDDEN : (0, $hZIhe.PageVisibleState).VISIBLE)
    };
};

});

parcelRegister("6EiMV", function(module, exports) {

$parcel$export(module.exports, "appFramework", () => $13790e5b33b0f1ce$export$e34e4529b979f74c);
const $13790e5b33b0f1ce$export$e34e4529b979f74c = (config)=>{
    if (!config.framework) return null;
    return {
        'app:framework:name': config.framework.name,
        'app:framework:version': config.framework.version
    };
};

});

parcelRegister("5PvFl", function(module, exports) {

$parcel$export(module.exports, "appVersion", () => $7a58380e732418fc$export$82ae485178b37419);
const $7a58380e732418fc$export$82ae485178b37419 = (config)=>{
    const pluginData = {
        'app:web:version': config.version.web
    };
    if (config.version.ssr) pluginData['app:ssr:version'] = config.version.ssr;
    return pluginData;
};

});

parcelRegister("7sb8G", function(module, exports) {

$parcel$export(module.exports, "eventBrowserPlugin", () => $7fbdc100c3e9e6eb$export$f435c2789ca334a7);

var $4XKM3 = parcelRequire("4XKM3");

var $8QpSo = parcelRequire("8QpSo");

var $cMCnl = parcelRequire("cMCnl");
const $7fbdc100c3e9e6eb$export$f435c2789ca334a7 = (0, $8QpSo.default)(()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($4XKM3))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($4XKM3))).getParser((0, $cMCnl.getWindowObject)()?.navigator?.userAgent || '');
    return {
        'event:browser:name': browser.getBrowserName(),
        'event:browser:version': browser.getBrowserVersion()
    };
});

});

parcelRegister("9c4Xf", function(module, exports) {

$parcel$export(module.exports, "eventCpusPlugin", () => $0d5677a9f00706ce$export$db7649b8854107ad);

var $8QpSo = parcelRequire("8QpSo");
const $0d5677a9f00706ce$export$db7649b8854107ad = (0, $8QpSo.default)(()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'event:cpus': navigator.hardwareConcurrency
    };
});

});

parcelRegister("3Yuby", function(module, exports) {

$parcel$export(module.exports, "featureFlags", () => $a36981977d353ef3$export$e62953d023125748);
const $a36981977d353ef3$export$e62953d023125748 = (featureFlagClient, featureFlags, data)=>{
    const allFeatureFlags = [
        ...featureFlags,
        ...data.featureFlags || []
    ];
    if (allFeatureFlags.length === 0) return null;
    const initialMemo = [];
    allFeatureFlags.reduce((memo, featureFlagKey)=>{
        const ffVal = featureFlagClient.getValue(featureFlagKey);
        if (ffVal !== undefined && ffVal !== null) memo.push([
            featureFlagKey,
            ffVal
        ]);
        return memo;
    }, initialMemo);
    const mappedFeatureFlags = Object.fromEntries(initialMemo);
    return {
        featureFlags: mappedFeatureFlags
    };
};

});

parcelRegister("fligS", function(module, exports) {

$parcel$export(module.exports, "eventMemoryPlugin", () => $a57c7278a81a7670$export$81efaf8414879a1a);

var $8QpSo = parcelRequire("8QpSo");
const $a57c7278a81a7670$export$81efaf8414879a1a = (0, $8QpSo.default)(()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'event:memory': navigator.deviceMemory
    };
});

});

parcelRegister("j2LUD", function(module, exports) {

$parcel$export(module.exports, "eventNetworkPlugin", () => $68bf007c5547eb9c$export$ce1cf816dce1da56);
const $68bf007c5547eb9c$export$ce1cf816dce1da56 = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("cKlMl", function(module, exports) {

$parcel$export(module.exports, "ssrFeatureFlags", () => $46f66567464d79f5$export$fdbea518c19dfa8);
const $46f66567464d79f5$export$fdbea518c19dfa8 = (ssr)=>{
    if (!ssr?.getFeatureFlags) return null;
    try {
        const featureFlags = ssr.getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};

});

parcelRegister("27a2m", function(module, exports) {

$parcel$export(module.exports, "ssrSuccess", () => $26c7eba74ba1e532$export$a3dc8251cf55b2e0);
const $26c7eba74ba1e532$export$a3dc8251cf55b2e0 = (ssr)=>{
    if (ssr?.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("4FqrW", function(module, exports) {

$parcel$export(module.exports, "Route", () => $064431f7fe44dc32$export$e7b0ac011bb776c6);
const $064431f7fe44dc32$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});


const $84d640425696d0a7$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $84d640425696d0a7$export$f005e2e9f707cb5f = 'commercial';
const $84d640425696d0a7$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $84d640425696d0a7$export$a739cd5aac835909 = 'stg';
const $84d640425696d0a7$export$42dd0cdd351a4a9 = 'prod';
const $84d640425696d0a7$export$404582bc18fe4d9e = 'dev';

const $8d1bebd301ce3159$export$42f4885608027d0c = 'non_boolean';

const $29f48a019ac694c5$export$cf090d5281b5ae06 = 10000;
const $29f48a019ac694c5$export$8575e30be0feb909 = 30000;

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $e02bff6030c88515$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

// same types defined in analytics-web-client but avoid creating dependency with that
const $0427b8dcfa55f5cf$export$a1562d08625f5d7e = 'ui';
const $0427b8dcfa55f5cf$export$947dac6c72b26f81 = 'track';
const $0427b8dcfa55f5cf$export$f1d537d508d2945a = 'screen';
const $0427b8dcfa55f5cf$export$12346a674644c156 = 'operational';
const $0427b8dcfa55f5cf$export$b055de0e665cb20c = 'unknown';

const $050472091e39012b$export$3288b14b6745c572 = 204;
const $050472091e39012b$export$c09e7ea0fc79f34f = 409;
const $050472091e39012b$export$974c37534b0191b1 = 503;


$parcel$global.rlb("i5RRW")
//# sourceMappingURL=shared~commons~atlassian~ar.97b7f576.js.map
